unit Uzysk;

interface

uses
  SysUtils, Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, WEBLib.Imaging.pngimage, WEBLib.ExtCtrls,
  WEBLib.StdCtrls, Math, WEBLib.ComCtrls,
  WEBLib.Imaging.jpeg, WEBLib.WebCtrls;

type
  TForm1 = class(TForm)
    Rzut: TImageControl;
    WebLabel11: TLabel;
    WebLabel1: TLabel;
    Bok: TImageControl;
    Logo: TImageControl;
    WebLabel14: TLabel;
    WebLabel38: TLabel;
    FB: TImageControl;
    WebGroupBox3: TGroupBox;
    WebGroupBox4: TGroupBox;
    WebLabel20: TLabel;
    WebLabel21: TLabel;
    WebLabel22: TLabel;
    WebLabel23: TLabel;
    WebLabel2: TLabel;
    WebTrackBar1: TTrackBar;
    WebTrackBar2: TTrackBar;
    WebLabel3: TLabel;
    WebLabel4: TLabel;
    WebLabel5: TLabel;
    WebComboBox1: TComboBox;
    WebLabel6: TLabel;
    WebEdit2: TEdit;
    WebLabel7: TLabel;
    WebComboBox2: TComboBox;
    WebLabel8: TLabel;
    WebEdit1: TEdit;
    WebLabel9: TLabel;
    WebEdit3: TEdit;
    WebLabel10: TLabel;
    WebLabel12: TLabel;
    WebEdit4: TEdit;
    WebLabel13: TLabel;
    WebLabel15: TLabel;
    procedure WebTrackBar1Change(Sender: TObject);
    procedure WebTrackBar2Change(Sender: TObject);
    procedure WebComboBox1Change(Sender: TObject);
    procedure WebComboBox2Change(Sender: TObject);
  private
    { Private declarations }
  protected
    procedure LoadDFMValues; override;
  public
    { Public declarations }
  end;

var
  Form1     : TForm1;

implementation


function oblicz (k: Real; a: Real): Real;
 begin
  a:=Abs(a);
  if (k=0) and (a= 0) then Result := 87;
  if (k=10) and (a= 0) then Result := 93;
  if (k=20) and (a= 0) then Result := 97;
  if (k=30) and (a= 0) then Result := 100;
  if (k=40) and (a= 0) then Result := 100;
  if (k=50) and (a= 0) then Result := 98;
  if (k=60) and (a= 0) then Result := 94;
  if (k=70) and (a= 0) then Result := 80;
  if (k=80) and (a= 0) then Result := 80;
  if (k=90) and (a= 0) then Result := 69;

  if (k=0) and (a= 10) then Result := 87;
  if (k=10) and (a= 10) then Result := 93;
  if (k=20) and (a= 10) then Result := 97;
  if (k=30) and (a= 10) then Result := 99;
  if (k=40) and (a= 10) then Result := 99;
  if (k=50) and (a= 10) then Result := 97;
  if (k=60) and (a= 10) then Result := 93;
  if (k=70) and (a= 10) then Result := 87;
  if (k=80) and (a= 10) then Result := 79;
  if (k=90) and (a= 10) then Result := 69;

  if (k=0) and (a= 20) then Result := 87;
  if (k=10) and (a= 20) then Result := 93;
  if (k=20) and (a= 20) then Result := 97;
  if (k=30) and (a= 20) then Result := 99;
  if (k=40) and (a= 20) then Result := 99;
  if (k=50) and (a= 20) then Result := 96;
  if (k=60) and (a= 20) then Result := 92;
  if (k=70) and (a= 20) then Result := 86;
  if (k=80) and (a= 20) then Result := 78;
  if (k=90) and (a= 20) then Result := 69;

  if (k=0) and (a= 30) then Result := 87;
  if (k=10) and (a= 30) then Result := 92;
  if (k=20) and (a= 30) then Result := 96;
  if (k=30) and (a= 30) then Result := 97;
  if (k=40) and (a= 30) then Result := 97;
  if (k=50) and (a= 30) then Result := 95;
  if (k=60) and (a= 30) then Result := 92;
  if (k=70) and (a= 30) then Result := 85;
  if (k=80) and (a= 30) then Result := 77;
  if (k=90) and (a= 30) then Result := 67;

  if (k=0) and (a= 40) then Result := 87;
  if (k=10) and (a= 40) then Result := 92;
  if (k=20) and (a= 40) then Result := 95;
  if (k=30) and (a= 40) then Result := 96;
  if (k=40) and (a= 40) then Result := 95;
  if (k=50) and (a= 40) then Result := 93;
  if (k=60) and (a= 40) then Result := 88;
  if (k=70) and (a= 40) then Result := 82;
  if (k=80) and (a= 40) then Result := 75;
  if (k=90) and (a= 40) then Result := 65;

  if (k=0) and (a= 50) then Result := 87;
  if (k=10) and (a= 50) then Result := 92;
  if (k=20) and (a= 50) then Result := 93;
  if (k=30) and (a= 50) then Result := 94;
  if (k=40) and (a= 50) then Result := 93;
  if (k=50) and (a= 50) then Result := 90;
  if (k=60) and (a= 50) then Result := 85;
  if (k=70) and (a= 50) then Result := 79;
  if (k=80) and (a= 50) then Result := 72;
  if (k=90) and (a= 50) then Result := 63;

  if (k=0) and (a= 60) then Result := 87;
  if (k=10) and (a= 60) then Result := 90;
  if (k=20) and (a= 60) then Result := 91;
  if (k=30) and (a= 60) then Result := 91;
  if (k=40) and (a= 60) then Result := 90;
  if (k=50) and (a= 60) then Result := 87;
  if (k=60) and (a= 60) then Result := 82;
  if (k=70) and (a= 60) then Result := 76;
  if (k=80) and (a= 60) then Result := 60;
  if (k=90) and (a= 60) then Result := 60;

  if (k=0) and (a= 70) then Result := 87;
  if (k=10) and (a= 70) then Result := 89;
  if (k=20) and (a= 70) then Result := 89;
  if (k=30) and (a= 70) then Result := 88;
  if (k=40) and (a= 70) then Result := 86;
  if (k=50) and (a= 70) then Result := 83;
  if (k=60) and (a= 70) then Result := 78;
  if (k=70) and (a= 70) then Result := 72;
  if (k=80) and (a= 70) then Result := 65;
  if (k=90) and (a= 70) then Result := 56;

  if (k=0) and (a= 80) then Result := 87;
  if (k=10) and (a= 80) then Result := 88;
  if (k=20) and (a= 80) then Result := 87;
  if (k=30) and (a= 80) then Result := 85;
  if (k=40) and (a= 80) then Result := 83;
  if (k=50) and (a= 80) then Result := 79;
  if (k=60) and (a= 80) then Result := 74;
  if (k=70) and (a= 80) then Result := 68;
  if (k=80) and (a= 80) then Result := 61;
  if (k=90) and (a= 80) then Result := 52;

  if (k=0) and (a= 90) then Result := 87;
  if (k=10) and (a= 90) then Result := 86;
  if (k=20) and (a= 90) then Result := 85;
  if (k=30) and (a= 90) then Result := 82;
  if (k=40) and (a= 90) then Result := 79;
  if (k=50) and (a= 90) then Result := 75;
  if (k=60) and (a= 90) then Result := 70;
  if (k=70) and (a= 90) then Result := 70;
  if (k=80) and (a= 90) then Result := 56;
  if (k=90) and (a= 90) then Result := 48;

  if (k=0) and (a= 100) then Result := 87;
  if (k=10) and (a= 100) then Result := 85;
  if (k=20) and (a= 100) then Result := 82;
  if (k=30) and (a= 100) then Result := 79;
  if (k=40) and (a= 100) then Result := 75;
  if (k=50) and (a= 100) then Result := 70;
  if (k=60) and (a= 100) then Result := 63;
  if (k=70) and (a= 100) then Result := 58;
  if (k=80) and (a= 100) then Result := 52;
  if (k=90) and (a= 100) then Result := 44;

  if (k=0) and (a= 110) then Result := 87;
  if (k=10) and (a= 110) then Result := 84;
  if (k=20) and (a= 110) then Result := 80;
  if (k=30) and (a= 110) then Result := 75;
  if (k=40) and (a= 110) then Result := 71;
  if (k=50) and (a= 110) then Result := 66;
  if (k=60) and (a= 110) then Result := 60;
  if (k=70) and (a= 110) then Result := 50;
  if (k=80) and (a= 110) then Result := 47;
  if (k=90) and (a= 110) then Result := 40;

  if (k=0) and (a= 120) then Result := 87;
  if (k=10) and (a= 120) then Result := 83;
  if (k=20) and (a= 120) then Result := 77;
  if (k=30) and (a= 120) then Result := 72;
  if (k=40) and (a= 120) then Result := 67;
  if (k=50) and (a= 120) then Result := 61;
  if (k=60) and (a= 120) then Result := 55;
  if (k=70) and (a= 120) then Result := 49;
  if (k=80) and (a= 120) then Result := 42;
  if (k=90) and (a= 120) then Result := 35;

  if (k=0) and (a= 130) then Result := 87;
  if (k=10) and (a= 130) then Result := 81;
  if (k=20) and (a= 130) then Result := 75;
  if (k=30) and (a= 130) then Result := 69;
  if (k=40) and (a= 130) then Result := 63;
  if (k=50) and (a= 130) then Result := 56;
  if (k=60) and (a= 130) then Result := 50;
  if (k=70) and (a= 130) then Result := 44;
  if (k=80) and (a= 130) then Result := 37;
  if (k=90) and (a= 130) then Result := 31;

  if (k=0) and (a= 140) then Result := 87;
  if (k=10) and (a= 140) then Result := 81;
  if (k=20) and (a= 140) then Result := 73;
  if (k=30) and (a= 140) then Result := 66;
  if (k=40) and (a= 140) then Result := 59;
  if (k=50) and (a= 140) then Result := 52;
  if (k=60) and (a= 140) then Result := 46;
  if (k=70) and (a= 140) then Result := 39;
  if (k=80) and (a= 140) then Result := 33;
  if (k=90) and (a= 140) then Result := 27;

  if (k=0) and (a= 150) then Result := 87;
  if (k=10) and (a= 150) then Result := 80;
  if (k=20) and (a= 150) then Result := 71;
  if (k=30) and (a= 150) then Result := 64;
  if (k=40) and (a= 150) then Result := 56;
  if (k=50) and (a= 150) then Result := 48;
  if (k=60) and (a= 150) then Result := 41;
  if (k=70) and (a= 150) then Result := 35;
  if (k=80) and (a= 150) then Result := 29;
  if (k=90) and (a= 150) then Result := 24;

  if (k=0) and (a= 160) then Result := 87;
  if (k=10) and (a= 160) then Result := 79;
  if (k=20) and (a= 160) then Result := 70;
  if (k=30) and (a= 160) then Result := 62;
  if (k=40) and (a= 160) then Result := 54;
  if (k=50) and (a= 160) then Result := 45;
  if (k=60) and (a= 160) then Result := 38;
  if (k=70) and (a= 160) then Result := 32;
  if (k=80) and (a= 160) then Result := 26;
  if (k=90) and (a= 160) then Result := 21;

  if (k=0) and (a= 170) then Result := 87;
  if (k=10) and (a= 170) then Result := 79;
  if (k=20) and (a= 170) then Result := 70;
  if (k=30) and (a= 170) then Result := 61;
  if (k=40) and (a= 170) then Result := 52;
  if (k=50) and (a= 170) then Result := 44;
  if (k=60) and (a= 170) then Result := 36;
  if (k=70) and (a= 170) then Result := 29;
  if (k=80) and (a= 170) then Result := 24;
  if (k=90) and (a= 170) then Result := 19;

  if (k=0) and (a= 180) then Result := 87;
  if (k=10) and (a= 180) then Result := 79;
  if (k=20) and (a= 180) then Result := 70;
  if (k=30) and (a= 180) then Result := 61;
  if (k=40) and (a= 180) then Result := 52;
  if (k=50) and (a= 180) then Result := 43;
  if (k=60) and (a= 180) then Result := 35;
  if (k=70) and (a= 180) then Result := 28;
  if (k=80) and (a= 180) then Result := 23;
  if (k=90) and (a= 180) then Result := 18;

end;

procedure TForm1.WebComboBox1Change(Sender: TObject);
var   KAT, AZY, UZY, ENE        : Real;
      DIC2, DIC1                : String;
begin
    KAT:=WebTrackBar2.Position;

  if (KAT>0) AND (KAT<=10) then KAT:=10;
  if (KAT>10) AND (KAT<=20) then KAT:=20;
  if (KAT>20) AND (KAT<=30) then KAT:=30;
  if (KAT>30) AND (KAT<=40) then KAT:=40;
  if (KAT>40) AND (KAT<=50) then KAT:=50;
  if (KAT>50) AND (KAT<=60) then KAT:=60;
  if (KAT>60) AND (KAT<=70) then KAT:=70;
  if (KAT>70) AND (KAT<=80) then KAT:=80;
  if (KAT>80) AND (KAT<=90) then KAT:=90;

    AZY:=WebTrackBar1.Position;

    if (AZY>-90) AND (AZY<90) then WebLabel5.Caption:='S';
    if (AZY<=-90) then WebLabel5.Caption:='N';
    if (AZY>=90) then WebLabel5.Caption:='N';

  if (AZY=0) then begin DIC1:='Rzut0.png'; UZY:=oblicz(KAT,0); end;

  if (AZY>0) AND (AZY<=10) then begin DIC1:='Rzut10W.png'; UZY:=oblicz(KAT,10); end;
  if (AZY<0) AND (AZY>=-10) then begin DIC1:='Rzut10E.png'; UZY:=oblicz(KAT,10); end;

  if (AZY>10) AND (AZY<=20) then begin DIC1:='Rzut20W.png'; UZY:=oblicz(KAT,20); end;
  if (AZY<-10) AND (AZY>=-20) then begin DIC1:='Rzut20E.png'; UZY:=oblicz(KAT,20);end;

  if (AZY>20) AND (AZY<=30) then begin DIC1:='Rzut30W.png'; UZY:=oblicz(KAT,30);end;
  if (AZY<-20) AND (AZY>=-30) then begin DIC1:='Rzut30E.png'; UZY:=oblicz(KAT,30);end;

  if (AZY>30) AND (AZY<=40) then begin DIC1:='Rzut40W.png'; UZY:=oblicz(KAT,40);end;
  if (AZY<-30) AND (AZY>=-40) then begin DIC1:='Rzut40E.png'; UZY:=oblicz(KAT,40);end;

  if (AZY>40) AND (AZY<=50) then begin DIC1:='Rzut50W.png'; UZY:=oblicz(KAT,50);end;
  if (AZY<-40) AND (AZY>=-50) then begin DIC1:='Rzut50E.png'; UZY:=oblicz(KAT,50);end;

  if (AZY>50) AND (AZY<=60) then begin DIC1:='Rzut60W.png'; UZY:=oblicz(KAT,60); end;
  if (AZY<-50) AND (AZY>=-60) then begin DIC1:='Rzut60E.png'; UZY:=oblicz(KAT,60); end;

  if (AZY>60) AND (AZY<=70) then begin DIC1:='Rzut70W.png'; UZY:=oblicz(KAT,70);end;
  if (AZY<-60) AND (AZY>=-70) then begin DIC1:='Rzut70E.png'; UZY:=oblicz(KAT,70);end;

  if (AZY>70) AND (AZY<=80) then begin DIC1:='Rzut80W.png'; UZY:=oblicz(KAT,80);end;
  if (AZY<-70) AND (AZY>=-80) then begin DIC1:='Rzut80E.png'; UZY:=oblicz(KAT,80);end;

  if (AZY>80) AND (AZY<=90) then begin DIC1:='Rzut90W.png'; UZY:=oblicz(KAT,90);end;
  if  (AZY<-80) AND (AZY>=-90) then begin DIC1:='Rzut90E.png'; UZY:=oblicz(KAT,90);end;

  if (AZY>90) AND (AZY<=100) then begin DIC1:='Rzut100W.png'; UZY:=oblicz(KAT,100);end;
  if  (AZY<-90) AND (AZY>=-100) then begin DIC1:='Rzut100E.png'; UZY:=oblicz(KAT,100);end;

  if (AZY>100) AND (AZY<=110) then begin DIC1:='Rzut110W.png'; UZY:=oblicz(KAT,110);end;
  if  (AZY<-100) AND (AZY>=-110) then begin DIC1:='Rzut110E.png'; UZY:=oblicz(KAT,110);end;

  if (AZY>110) AND (AZY<=120) then begin DIC1:='Rzut120W.png'; UZY:=oblicz(KAT,120);end;
  if  (AZY<-110) AND (AZY>=-120) then begin DIC1:='Rzut120E.png'; UZY:=oblicz(KAT,120);end;

  if (AZY>120) AND (AZY<=130) then begin DIC1:='Rzut130W.png'; UZY:=oblicz(KAT,130);end;
  if  (AZY<-120) AND (AZY>=-130) then begin DIC1:='Rzut130E.png'; UZY:=oblicz(KAT,130);end;

  if (AZY>130) AND (AZY<=140) then begin DIC1:='Rzut140W.png'; UZY:=oblicz(KAT,140);end;
  if  (AZY<-130) AND (AZY>=-140) then begin DIC1:='Rzut140E.png'; UZY:=oblicz(KAT,140);end;

  if (AZY>140) AND (AZY<=150) then begin DIC1:='Rzut150W.png'; UZY:=oblicz(KAT,150);end;
  if  (AZY<-140) AND (AZY>=-150) then begin DIC1:='Rzut150E.png'; UZY:=oblicz(KAT,150);end;

  if (AZY>150) AND (AZY<=160) then begin DIC1:='Rzut160W.png'; UZY:=oblicz(KAT,160);end;
  if  (AZY<-150) AND (AZY>=-160) then begin DIC1:='Rzut160E.png'; UZY:=oblicz(KAT,160);end;

  if (AZY>160) AND (AZY<=179) then begin DIC1:='Rzut170W.png'; UZY:=oblicz(KAT,170);end;
  if  (AZY<-160) AND (AZY>=-179) then begin DIC1:='Rzut170E.png'; UZY:=oblicz(KAT,170);end;

  if  (AZY=180) then begin DIC1:='Rzut180.png'; UZY:=oblicz(KAT,180); end;
  if  (AZY=-180) then begin DIC1:='Rzut180.png'; UZY:=oblicz(KAT,180); end;

   DIC1:='img\'+DIC1;
   WebEdit4.Text:=FloattoStr(UZY/100);
   ENE:=UZY*StrtoFloat(WEBComboBox1.Text)*StrtoFloat(WEBComboBox2.Text)/1000;
   WebEdit2.Text:=FloattoStr(ENE/100);
   Rzut.URL:=DIC1;

  AZY:=WebTrackBar1.Position;

  if (AZY>0) AND (AZY<=10) then AZY:=10;
  if (AZY>10) AND (AZY<=20) then AZY:=20;
  if (AZY>20) AND (AZY<=30) then AZY:=30;
  if (AZY>30) AND (AZY<=40) then AZY:=40;
  if (AZY>40) AND (AZY<=50) then AZY:=50;
  if (AZY>50) AND (AZY<=60) then AZY:=60;
  if (AZY>60) AND (AZY<=70) then AZY:=70;
  if (AZY>70) AND (AZY<=80) then AZY:=80;
  if (AZY>80) AND (AZY<=90) then AZY:=90;
  if (AZY>90) AND (AZY<=100) then AZY:=100;
  if (AZY>100) AND (AZY<=110) then AZY:=110;
  if (AZY>110) AND (AZY<=120) then AZY:=120;
  if (AZY>120) AND (AZY<=130) then AZY:=130;
  if (AZY>130) AND (AZY<=140) then AZY:=140;
  if (AZY>140) AND (AZY<=150) then AZY:=150;
  if (AZY>150) AND (AZY<=160) then AZY:=160;
  if (AZY>160) AND (AZY<=170) then AZY:=170;
  if (AZY>170) AND (AZY<=180) then AZY:=180;

  WebLabel2.Caption:= 'Kąt = '+FloattoStr(KAT)+' st.';

  if KAT=0 then DIC2:='Bok0.png';

  if (KAT>0) AND (KAT<=10) then begin
    if WebLabel5.Caption='N' then DIC2:='Bok10N.png'; end;
  if (KAT>0) AND (KAT<=10) then begin
    if WebLabel5.Caption='S' then DIC2:='Bok10S.png'; end;

  if (KAT>10) AND (KAT<=20) then begin
    if WebLabel5.Caption='N' then DIC2:='Bok20N.png'; end;
  if (KAT>10) AND (KAT<=20) then begin
    if WebLabel5.Caption='S' then DIC2:='Bok20S.png'; end;

  if (KAT>20) AND (KAT<=30) then begin
    if WebLabel5.Caption='N' then DIC2:='Bok30N.png'; end;
  if (KAT>20) AND (KAT<=30) then begin
    if WebLabel5.Caption='S' then DIC2:='Bok30S.png'; end;

  if (KAT>30) AND (KAT<=40) then begin
    if WebLabel5.Caption='N' then DIC2:='Bok40N.png'; end;
  if (KAT>30) AND (KAT<=40) then begin
    if WebLabel5.Caption='S' then DIC2:='Bok40S.png'; end;

  if (KAT>40) AND (KAT<=50) then begin
    if WebLabel5.Caption='N' then DIC2:='Bok50N.png'; end;
  if (KAT>40) AND (KAT<=50) then begin
    if WebLabel5.Caption='S' then DIC2:='Bok50S.png'; end;

  if (KAT>50)AND (KAT<=60) then begin
    if WebLabel5.Caption='N' then DIC2:='Bok60N.png'; end;
  if (KAT>50) AND (KAT<=60) then begin
    if WebLabel5.Caption='S' then DIC2:='Bok60S.png'; end;

  if (KAT>60) AND (KAT<=70) then begin
    if WebLabel5.Caption='N' then DIC2:='Bok70N.png'; end;
  if (KAT>60) AND (KAT<=70) then begin
    if WebLabel5.Caption='S' then DIC2:='Bok70S.png'; end;

  if (KAT>70) AND (KAT<=89) then begin
    if WebLabel5.Caption='N' then DIC2:='Bok80N.png'; end;
  if (KAT>70) AND (KAT<=89) then begin
    if WebLabel5.Caption='S' then DIC2:='Bok80S.png'; end;

  if KAT=90 then begin
      if WebLabel5.Caption='N' then DIC2:='Bok90N.png'; end;
  if KAT=90 then begin
      if WebLabel5.Caption='S' then DIC2:='Bok90S.png'; end;

  WebLabel11.Caption:= 'Azymut = '+FloattoStr(AZY);
   DIC2:='img\'+DIC2;
  Bok.URL:=DIC2;
end;

procedure TForm1.WebComboBox2Change(Sender: TObject);
var   KAT, AZY, UZY, ENE        : Real;
      DIC2, DIC1                : String;
begin
    KAT:=WebTrackBar2.Position;

  if (KAT>0) AND (KAT<=10) then KAT:=10;
  if (KAT>10) AND (KAT<=20) then KAT:=20;
  if (KAT>20) AND (KAT<=30) then KAT:=30;
  if (KAT>30) AND (KAT<=40) then KAT:=40;
  if (KAT>40) AND (KAT<=50) then KAT:=50;
  if (KAT>50) AND (KAT<=60) then KAT:=60;
  if (KAT>60) AND (KAT<=70) then KAT:=70;
  if (KAT>70) AND (KAT<=80) then KAT:=80;
  if (KAT>80) AND (KAT<=90) then KAT:=90;

    AZY:=WebTrackBar1.Position;

    if (AZY>-90) AND (AZY<90) then WebLabel5.Caption:='S';
    if (AZY<=-90) then WebLabel5.Caption:='N';
    if (AZY>=90) then WebLabel5.Caption:='N';

  if (AZY=0) then begin DIC1:='Rzut0.png'; UZY:=oblicz(KAT,0); end;

  if (AZY>0) AND (AZY<=10) then begin DIC1:='Rzut10W.png'; UZY:=oblicz(KAT,10); end;
  if (AZY<0) AND (AZY>=-10) then begin DIC1:='Rzut10E.png'; UZY:=oblicz(KAT,10); end;

  if (AZY>10) AND (AZY<=20) then begin DIC1:='Rzut20W.png'; UZY:=oblicz(KAT,20); end;
  if (AZY<-10) AND (AZY>=-20) then begin DIC1:='Rzut20E.png'; UZY:=oblicz(KAT,20);end;

  if (AZY>20) AND (AZY<=30) then begin DIC1:='Rzut30W.png'; UZY:=oblicz(KAT,30);end;
  if (AZY<-20) AND (AZY>=-30) then begin DIC1:='Rzut30E.png'; UZY:=oblicz(KAT,30);end;

  if (AZY>30) AND (AZY<=40) then begin DIC1:='Rzut40W.png'; UZY:=oblicz(KAT,40);end;
  if (AZY<-30) AND (AZY>=-40) then begin DIC1:='Rzut40E.png'; UZY:=oblicz(KAT,40);end;

  if (AZY>40) AND (AZY<=50) then begin DIC1:='Rzut50W.png'; UZY:=oblicz(KAT,50);end;
  if (AZY<-40) AND (AZY>=-50) then begin DIC1:='Rzut50E.png'; UZY:=oblicz(KAT,50);end;

  if (AZY>50) AND (AZY<=60) then begin DIC1:='Rzut60W.png'; UZY:=oblicz(KAT,60); end;
  if (AZY<-50) AND (AZY>=-60) then begin DIC1:='Rzut60E.png'; UZY:=oblicz(KAT,60); end;

  if (AZY>60) AND (AZY<=70) then begin DIC1:='Rzut70W.png'; UZY:=oblicz(KAT,70);end;
  if (AZY<-60) AND (AZY>=-70) then begin DIC1:='Rzut70E.png'; UZY:=oblicz(KAT,70);end;

  if (AZY>70) AND (AZY<=80) then begin DIC1:='Rzut80W.png'; UZY:=oblicz(KAT,80);end;
  if (AZY<-70) AND (AZY>=-80) then begin DIC1:='Rzut80E.png'; UZY:=oblicz(KAT,80);end;

  if (AZY>80) AND (AZY<=90) then begin DIC1:='Rzut90W.png'; UZY:=oblicz(KAT,90);end;
  if  (AZY<-80) AND (AZY>=-90) then begin DIC1:='Rzut90E.png'; UZY:=oblicz(KAT,90);end;

  if (AZY>90) AND (AZY<=100) then begin DIC1:='Rzut100W.png'; UZY:=oblicz(KAT,100);end;
  if  (AZY<-90) AND (AZY>=-100) then begin DIC1:='Rzut100E.png'; UZY:=oblicz(KAT,100);end;

  if (AZY>100) AND (AZY<=110) then begin DIC1:='Rzut110W.png'; UZY:=oblicz(KAT,110);end;
  if  (AZY<-100) AND (AZY>=-110) then begin DIC1:='Rzut110E.png'; UZY:=oblicz(KAT,110);end;

  if (AZY>110) AND (AZY<=120) then begin DIC1:='Rzut120W.png'; UZY:=oblicz(KAT,120);end;
  if  (AZY<-110) AND (AZY>=-120) then begin DIC1:='Rzut120E.png'; UZY:=oblicz(KAT,120);end;

  if (AZY>120) AND (AZY<=130) then begin DIC1:='Rzut130W.png'; UZY:=oblicz(KAT,130);end;
  if  (AZY<-120) AND (AZY>=-130) then begin DIC1:='Rzut130E.png'; UZY:=oblicz(KAT,130);end;

  if (AZY>130) AND (AZY<=140) then begin DIC1:='Rzut140W.png'; UZY:=oblicz(KAT,140);end;
  if  (AZY<-130) AND (AZY>=-140) then begin DIC1:='Rzut140E.png'; UZY:=oblicz(KAT,140);end;

  if (AZY>140) AND (AZY<=150) then begin DIC1:='Rzut150W.png'; UZY:=oblicz(KAT,150);end;
  if  (AZY<-140) AND (AZY>=-150) then begin DIC1:='Rzut150E.png'; UZY:=oblicz(KAT,150);end;

  if (AZY>150) AND (AZY<=160) then begin DIC1:='Rzut160W.png'; UZY:=oblicz(KAT,160);end;
  if  (AZY<-150) AND (AZY>=-160) then begin DIC1:='Rzut160E.png'; UZY:=oblicz(KAT,160);end;

  if (AZY>160) AND (AZY<=179) then begin DIC1:='Rzut170W.png'; UZY:=oblicz(KAT,170);end;
  if  (AZY<-160) AND (AZY>=-179) then begin DIC1:='Rzut170E.png'; UZY:=oblicz(KAT,170);end;

  if  (AZY=180) then begin DIC1:='Rzut180.png'; UZY:=oblicz(KAT,180); end;
  if  (AZY=-180) then begin DIC1:='Rzut180.png'; UZY:=oblicz(KAT,180); end;

   DIC1:='img\'+DIC1;
   WebEdit4.Text:=FloattoStr(UZY/100);
   ENE:=UZY*StrtoFloat(WEBComboBox1.Text)*StrtoFloat(WEBComboBox2.Text)/1000;
   WebEdit2.Text:=FloattoStr(ENE/100);
   Rzut.URL:=DIC1;

  AZY:=WebTrackBar1.Position;

  if (AZY>0) AND (AZY<=10) then AZY:=10;
  if (AZY>10) AND (AZY<=20) then AZY:=20;
  if (AZY>20) AND (AZY<=30) then AZY:=30;
  if (AZY>30) AND (AZY<=40) then AZY:=40;
  if (AZY>40) AND (AZY<=50) then AZY:=50;
  if (AZY>50) AND (AZY<=60) then AZY:=60;
  if (AZY>60) AND (AZY<=70) then AZY:=70;
  if (AZY>70) AND (AZY<=80) then AZY:=80;
  if (AZY>80) AND (AZY<=90) then AZY:=90;
  if (AZY>90) AND (AZY<=100) then AZY:=100;
  if (AZY>100) AND (AZY<=110) then AZY:=110;
  if (AZY>110) AND (AZY<=120) then AZY:=120;
  if (AZY>120) AND (AZY<=130) then AZY:=130;
  if (AZY>130) AND (AZY<=140) then AZY:=140;
  if (AZY>140) AND (AZY<=150) then AZY:=150;
  if (AZY>150) AND (AZY<=160) then AZY:=160;
  if (AZY>160) AND (AZY<=170) then AZY:=170;
  if (AZY>170) AND (AZY<=180) then AZY:=180;

  WebLabel2.Caption:= 'Kąt = '+FloattoStr(KAT)+' st.';

  if KAT=0 then DIC2:='Bok0.png';

  if (KAT>0) AND (KAT<=10) then begin
    if WebLabel5.Caption='N' then DIC2:='Bok10N.png'; end;
  if (KAT>0) AND (KAT<=10) then begin
    if WebLabel5.Caption='S' then DIC2:='Bok10S.png'; end;

  if (KAT>10) AND (KAT<=20) then begin
    if WebLabel5.Caption='N' then DIC2:='Bok20N.png'; end;
  if (KAT>10) AND (KAT<=20) then begin
    if WebLabel5.Caption='S' then DIC2:='Bok20S.png'; end;

  if (KAT>20) AND (KAT<=30) then begin
    if WebLabel5.Caption='N' then DIC2:='Bok30N.png'; end;
  if (KAT>20) AND (KAT<=30) then begin
    if WebLabel5.Caption='S' then DIC2:='Bok30S.png'; end;

  if (KAT>30) AND (KAT<=40) then begin
    if WebLabel5.Caption='N' then DIC2:='Bok40N.png'; end;
  if (KAT>30) AND (KAT<=40) then begin
    if WebLabel5.Caption='S' then DIC2:='Bok40S.png'; end;

  if (KAT>40) AND (KAT<=50) then begin
    if WebLabel5.Caption='N' then DIC2:='Bok50N.png'; end;
  if (KAT>40) AND (KAT<=50) then begin
    if WebLabel5.Caption='S' then DIC2:='Bok50S.png'; end;

  if (KAT>50)AND (KAT<=60) then begin
    if WebLabel5.Caption='N' then DIC2:='Bok60N.png'; end;
  if (KAT>50) AND (KAT<=60) then begin
    if WebLabel5.Caption='S' then DIC2:='Bok60S.png'; end;

  if (KAT>60) AND (KAT<=70) then begin
    if WebLabel5.Caption='N' then DIC2:='Bok70N.png'; end;
  if (KAT>60) AND (KAT<=70) then begin
    if WebLabel5.Caption='S' then DIC2:='Bok70S.png'; end;

  if (KAT>70) AND (KAT<=89) then begin
    if WebLabel5.Caption='N' then DIC2:='Bok80N.png'; end;
  if (KAT>70) AND (KAT<=89) then begin
    if WebLabel5.Caption='S' then DIC2:='Bok80S.png'; end;

  if KAT=90 then begin
      if WebLabel5.Caption='N' then DIC2:='Bok90N.png'; end;
  if KAT=90 then begin
      if WebLabel5.Caption='S' then DIC2:='Bok90S.png'; end;

  WebLabel11.Caption:= 'Azymut = '+FloattoStr(AZY);
   DIC2:='img\'+DIC2;
  Bok.URL:=DIC2;
end;

procedure TForm1.WebTrackBar1Change(Sender: TObject);
var   KAT, AZY, UZY, ENE        : Real;
      DIC2, DIC1                : String;
begin
    KAT:=WebTrackBar2.Position;

  if (KAT>0) AND (KAT<=10) then KAT:=10;
  if (KAT>10) AND (KAT<=20) then KAT:=20;
  if (KAT>20) AND (KAT<=30) then KAT:=30;
  if (KAT>30) AND (KAT<=40) then KAT:=40;
  if (KAT>40) AND (KAT<=50) then KAT:=50;
  if (KAT>50) AND (KAT<=60) then KAT:=60;
  if (KAT>60) AND (KAT<=70) then KAT:=70;
  if (KAT>70) AND (KAT<=80) then KAT:=80;
  if (KAT>80) AND (KAT<=90) then KAT:=90;

    AZY:=WebTrackBar1.Position;

    if (AZY>-90) AND (AZY<90) then WebLabel5.Caption:='S';
    if (AZY<=-90) then WebLabel5.Caption:='N';
    if (AZY>=90) then WebLabel5.Caption:='N';

  if (AZY=0) then begin DIC1:='Rzut0.png'; UZY:=oblicz(KAT,0); end;

  if (AZY>0) AND (AZY<=10) then begin DIC1:='Rzut10W.png'; UZY:=oblicz(KAT,10); end;
  if (AZY<0) AND (AZY>=-10) then begin DIC1:='Rzut10E.png'; UZY:=oblicz(KAT,10); end;

  if (AZY>10) AND (AZY<=20) then begin DIC1:='Rzut20W.png'; UZY:=oblicz(KAT,20); end;
  if (AZY<-10) AND (AZY>=-20) then begin DIC1:='Rzut20E.png'; UZY:=oblicz(KAT,20);end;

  if (AZY>20) AND (AZY<=30) then begin DIC1:='Rzut30W.png'; UZY:=oblicz(KAT,30);end;
  if (AZY<-20) AND (AZY>=-30) then begin DIC1:='Rzut30E.png'; UZY:=oblicz(KAT,30);end;

  if (AZY>30) AND (AZY<=40) then begin DIC1:='Rzut40W.png'; UZY:=oblicz(KAT,40);end;
  if (AZY<-30) AND (AZY>=-40) then begin DIC1:='Rzut40E.png'; UZY:=oblicz(KAT,40);end;

  if (AZY>40) AND (AZY<=50) then begin DIC1:='Rzut50W.png'; UZY:=oblicz(KAT,50);end;
  if (AZY<-40) AND (AZY>=-50) then begin DIC1:='Rzut50E.png'; UZY:=oblicz(KAT,50);end;

  if (AZY>50) AND (AZY<=60) then begin DIC1:='Rzut60W.png'; UZY:=oblicz(KAT,60); end;
  if (AZY<-50) AND (AZY>=-60) then begin DIC1:='Rzut60E.png'; UZY:=oblicz(KAT,60); end;

  if (AZY>60) AND (AZY<=70) then begin DIC1:='Rzut70W.png'; UZY:=oblicz(KAT,70);end;
  if (AZY<-60) AND (AZY>=-70) then begin DIC1:='Rzut70E.png'; UZY:=oblicz(KAT,70);end;

  if (AZY>70) AND (AZY<=80) then begin DIC1:='Rzut80W.png'; UZY:=oblicz(KAT,80);end;
  if (AZY<-70) AND (AZY>=-80) then begin DIC1:='Rzut80E.png'; UZY:=oblicz(KAT,80);end;

  if (AZY>80) AND (AZY<=90) then begin DIC1:='Rzut90W.png'; UZY:=oblicz(KAT,90);end;
  if  (AZY<-80) AND (AZY>=-90) then begin DIC1:='Rzut90E.png'; UZY:=oblicz(KAT,90);end;

  if (AZY>90) AND (AZY<=100) then begin DIC1:='Rzut100W.png'; UZY:=oblicz(KAT,100);end;
  if  (AZY<-90) AND (AZY>=-100) then begin DIC1:='Rzut100E.png'; UZY:=oblicz(KAT,100);end;

  if (AZY>100) AND (AZY<=110) then begin DIC1:='Rzut110W.png'; UZY:=oblicz(KAT,110);end;
  if  (AZY<-100) AND (AZY>=-110) then begin DIC1:='Rzut110E.png'; UZY:=oblicz(KAT,110);end;

  if (AZY>110) AND (AZY<=120) then begin DIC1:='Rzut120W.png'; UZY:=oblicz(KAT,120);end;
  if  (AZY<-110) AND (AZY>=-120) then begin DIC1:='Rzut120E.png'; UZY:=oblicz(KAT,120);end;

  if (AZY>120) AND (AZY<=130) then begin DIC1:='Rzut130W.png'; UZY:=oblicz(KAT,130);end;
  if  (AZY<-120) AND (AZY>=-130) then begin DIC1:='Rzut130E.png'; UZY:=oblicz(KAT,130);end;

  if (AZY>130) AND (AZY<=140) then begin DIC1:='Rzut140W.png'; UZY:=oblicz(KAT,140);end;
  if  (AZY<-130) AND (AZY>=-140) then begin DIC1:='Rzut140E.png'; UZY:=oblicz(KAT,140);end;

  if (AZY>140) AND (AZY<=150) then begin DIC1:='Rzut150W.png'; UZY:=oblicz(KAT,150);end;
  if  (AZY<-140) AND (AZY>=-150) then begin DIC1:='Rzut150E.png'; UZY:=oblicz(KAT,150);end;

  if (AZY>150) AND (AZY<=160) then begin DIC1:='Rzut160W.png'; UZY:=oblicz(KAT,160);end;
  if  (AZY<-150) AND (AZY>=-160) then begin DIC1:='Rzut160E.png'; UZY:=oblicz(KAT,160);end;

  if (AZY>160) AND (AZY<=179) then begin DIC1:='Rzut170W.png'; UZY:=oblicz(KAT,170);end;
  if  (AZY<-160) AND (AZY>=-179) then begin DIC1:='Rzut170E.png'; UZY:=oblicz(KAT,170);end;

  if  (AZY=180) then begin DIC1:='Rzut180.png'; UZY:=oblicz(KAT,180); end;
  if  (AZY=-180) then begin DIC1:='Rzut180.png'; UZY:=oblicz(KAT,180); end;

   DIC1:='img\'+DIC1;
   WebEdit4.Text:=FloattoStr(UZY/100);
   ENE:=UZY*StrtoFloat(WEBComboBox1.Text)*StrtoFloat(WEBComboBox2.Text)/1000;
   WebEdit2.Text:=FloattoStr(ENE/100);
   Rzut.URL:=DIC1;

  AZY:=WebTrackBar1.Position;

  if (AZY>0) AND (AZY<=10) then AZY:=10;
  if (AZY>10) AND (AZY<=20) then AZY:=20;
  if (AZY>20) AND (AZY<=30) then AZY:=30;
  if (AZY>30) AND (AZY<=40) then AZY:=40;
  if (AZY>40) AND (AZY<=50) then AZY:=50;
  if (AZY>50) AND (AZY<=60) then AZY:=60;
  if (AZY>60) AND (AZY<=70) then AZY:=70;
  if (AZY>70) AND (AZY<=80) then AZY:=80;
  if (AZY>80) AND (AZY<=90) then AZY:=90;
  if (AZY>90) AND (AZY<=100) then AZY:=100;
  if (AZY>100) AND (AZY<=110) then AZY:=110;
  if (AZY>110) AND (AZY<=120) then AZY:=120;
  if (AZY>120) AND (AZY<=130) then AZY:=130;
  if (AZY>130) AND (AZY<=140) then AZY:=140;
  if (AZY>140) AND (AZY<=150) then AZY:=150;
  if (AZY>150) AND (AZY<=160) then AZY:=160;
  if (AZY>160) AND (AZY<=170) then AZY:=170;
  if (AZY>170) AND (AZY<=180) then AZY:=180;

  WebLabel2.Caption:= 'Kąt = '+FloattoStr(KAT)+' st.';

  if KAT=0 then DIC2:='Bok0.png';

  if (KAT>0) AND (KAT<=10) then begin
    if WebLabel5.Caption='N' then DIC2:='Bok10N.png'; end;
  if (KAT>0) AND (KAT<=10) then begin
    if WebLabel5.Caption='S' then DIC2:='Bok10S.png'; end;

  if (KAT>10) AND (KAT<=20) then begin
    if WebLabel5.Caption='N' then DIC2:='Bok20N.png'; end;
  if (KAT>10) AND (KAT<=20) then begin
    if WebLabel5.Caption='S' then DIC2:='Bok20S.png'; end;

  if (KAT>20) AND (KAT<=30) then begin
    if WebLabel5.Caption='N' then DIC2:='Bok30N.png'; end;
  if (KAT>20) AND (KAT<=30) then begin
    if WebLabel5.Caption='S' then DIC2:='Bok30S.png'; end;

  if (KAT>30) AND (KAT<=40) then begin
    if WebLabel5.Caption='N' then DIC2:='Bok40N.png'; end;
  if (KAT>30) AND (KAT<=40) then begin
    if WebLabel5.Caption='S' then DIC2:='Bok40S.png'; end;

  if (KAT>40) AND (KAT<=50) then begin
    if WebLabel5.Caption='N' then DIC2:='Bok50N.png'; end;
  if (KAT>40) AND (KAT<=50) then begin
    if WebLabel5.Caption='S' then DIC2:='Bok50S.png'; end;

  if (KAT>50)AND (KAT<=60) then begin
    if WebLabel5.Caption='N' then DIC2:='Bok60N.png'; end;
  if (KAT>50) AND (KAT<=60) then begin
    if WebLabel5.Caption='S' then DIC2:='Bok60S.png'; end;

  if (KAT>60) AND (KAT<=70) then begin
    if WebLabel5.Caption='N' then DIC2:='Bok70N.png'; end;
  if (KAT>60) AND (KAT<=70) then begin
    if WebLabel5.Caption='S' then DIC2:='Bok70S.png'; end;

  if (KAT>70) AND (KAT<=89) then begin
    if WebLabel5.Caption='N' then DIC2:='Bok80N.png'; end;
  if (KAT>70) AND (KAT<=89) then begin
    if WebLabel5.Caption='S' then DIC2:='Bok80S.png'; end;

  if KAT=90 then begin
      if WebLabel5.Caption='N' then DIC2:='Bok90N.png'; end;
  if KAT=90 then begin
      if WebLabel5.Caption='S' then DIC2:='Bok90S.png'; end;

  WebLabel11.Caption:= 'Azymut = '+FloattoStr(AZY);
   DIC2:='img\'+DIC2;
  Bok.URL:=DIC2;
end;


procedure TForm1.WebTrackBar2Change(Sender: TObject);
var   KAT, AZY, UZY, ENE        : Real;
      DIC2, DIC1                : String;
begin
    KAT:=WebTrackBar2.Position;

  if (KAT>0) AND (KAT<=10) then KAT:=10;
  if (KAT>10) AND (KAT<=20) then KAT:=20;
  if (KAT>20) AND (KAT<=30) then KAT:=30;
  if (KAT>30) AND (KAT<=40) then KAT:=40;
  if (KAT>40) AND (KAT<=50) then KAT:=50;
  if (KAT>50) AND (KAT<=60) then KAT:=60;
  if (KAT>60) AND (KAT<=70) then KAT:=70;
  if (KAT>70) AND (KAT<=80) then KAT:=80;
  if (KAT>80) AND (KAT<=90) then KAT:=90;

    AZY:=WebTrackBar1.Position;

    if (AZY>-90) AND (AZY<90) then WebLabel5.Caption:='S';
    if (AZY<=-90) then WebLabel5.Caption:='N';
    if (AZY>=90) then WebLabel5.Caption:='N';

  if (AZY=0) then begin DIC1:='Rzut0.png'; UZY:=oblicz(KAT,0); end;

  if (AZY>0) AND (AZY<=10) then begin DIC1:='Rzut10W.png'; UZY:=oblicz(KAT,10); end;
  if (AZY<0) AND (AZY>=-10) then begin DIC1:='Rzut10E.png'; UZY:=oblicz(KAT,10); end;

  if (AZY>10) AND (AZY<=20) then begin DIC1:='Rzut20W.png'; UZY:=oblicz(KAT,20); end;
  if (AZY<-10) AND (AZY>=-20) then begin DIC1:='Rzut20E.png'; UZY:=oblicz(KAT,20);end;

  if (AZY>20) AND (AZY<=30) then begin DIC1:='Rzut30W.png'; UZY:=oblicz(KAT,30);end;
  if (AZY<-20) AND (AZY>=-30) then begin DIC1:='Rzut30E.png'; UZY:=oblicz(KAT,30);end;

  if (AZY>30) AND (AZY<=40) then begin DIC1:='Rzut40W.png'; UZY:=oblicz(KAT,40);end;
  if (AZY<-30) AND (AZY>=-40) then begin DIC1:='Rzut40E.png'; UZY:=oblicz(KAT,40);end;

  if (AZY>40) AND (AZY<=50) then begin DIC1:='Rzut50W.png'; UZY:=oblicz(KAT,50);end;
  if (AZY<-40) AND (AZY>=-50) then begin DIC1:='Rzut50E.png'; UZY:=oblicz(KAT,50);end;

  if (AZY>50) AND (AZY<=60) then begin DIC1:='Rzut60W.png'; UZY:=oblicz(KAT,60); end;
  if (AZY<-50) AND (AZY>=-60) then begin DIC1:='Rzut60E.png'; UZY:=oblicz(KAT,60); end;

  if (AZY>60) AND (AZY<=70) then begin DIC1:='Rzut70W.png'; UZY:=oblicz(KAT,70);end;
  if (AZY<-60) AND (AZY>=-70) then begin DIC1:='Rzut70E.png'; UZY:=oblicz(KAT,70);end;

  if (AZY>70) AND (AZY<=80) then begin DIC1:='Rzut80W.png'; UZY:=oblicz(KAT,80);end;
  if (AZY<-70) AND (AZY>=-80) then begin DIC1:='Rzut80E.png'; UZY:=oblicz(KAT,80);end;

  if (AZY>80) AND (AZY<=90) then begin DIC1:='Rzut90W.png'; UZY:=oblicz(KAT,90);end;
  if  (AZY<-80) AND (AZY>=-90) then begin DIC1:='Rzut90E.png'; UZY:=oblicz(KAT,90);end;

  if (AZY>90) AND (AZY<=100) then begin DIC1:='Rzut100W.png'; UZY:=oblicz(KAT,100);end;
  if  (AZY<-90) AND (AZY>=-100) then begin DIC1:='Rzut100E.png'; UZY:=oblicz(KAT,100);end;

  if (AZY>100) AND (AZY<=110) then begin DIC1:='Rzut110W.png'; UZY:=oblicz(KAT,110);end;
  if  (AZY<-100) AND (AZY>=-110) then begin DIC1:='Rzut110E.png'; UZY:=oblicz(KAT,110);end;

  if (AZY>110) AND (AZY<=120) then begin DIC1:='Rzut120W.png'; UZY:=oblicz(KAT,120);end;
  if  (AZY<-110) AND (AZY>=-120) then begin DIC1:='Rzut120E.png'; UZY:=oblicz(KAT,120);end;

  if (AZY>120) AND (AZY<=130) then begin DIC1:='Rzut130W.png'; UZY:=oblicz(KAT,130);end;
  if  (AZY<-120) AND (AZY>=-130) then begin DIC1:='Rzut130E.png'; UZY:=oblicz(KAT,130);end;

  if (AZY>130) AND (AZY<=140) then begin DIC1:='Rzut140W.png'; UZY:=oblicz(KAT,140);end;
  if  (AZY<-130) AND (AZY>=-140) then begin DIC1:='Rzut140E.png'; UZY:=oblicz(KAT,140);end;

  if (AZY>140) AND (AZY<=150) then begin DIC1:='Rzut150W.png'; UZY:=oblicz(KAT,150);end;
  if  (AZY<-140) AND (AZY>=-150) then begin DIC1:='Rzut150E.png'; UZY:=oblicz(KAT,150);end;

  if (AZY>150) AND (AZY<=160) then begin DIC1:='Rzut160W.png'; UZY:=oblicz(KAT,160);end;
  if  (AZY<-150) AND (AZY>=-160) then begin DIC1:='Rzut160E.png'; UZY:=oblicz(KAT,160);end;

  if (AZY>160) AND (AZY<=179) then begin DIC1:='Rzut170W.png'; UZY:=oblicz(KAT,170);end;
  if  (AZY<-160) AND (AZY>=-179) then begin DIC1:='Rzut170E.png'; UZY:=oblicz(KAT,170);end;

  if  (AZY=180) then begin DIC1:='Rzut180.png'; UZY:=oblicz(KAT,180); end;
  if  (AZY=-180) then begin DIC1:='Rzut180.png'; UZY:=oblicz(KAT,180); end;

   DIC1:='img\'+DIC1;
   WebEdit4.Text:=FloattoStr(UZY/100);
   ENE:=UZY*StrtoFloat(WEBComboBox1.Text)*StrtoFloat(WEBComboBox2.Text)/1000;
   WebEdit2.Text:=FloattoStr(ENE/100);
   Rzut.URL:=DIC1;

  AZY:=WebTrackBar1.Position;

  if (AZY>0) AND (AZY<=10) then AZY:=10;
  if (AZY>10) AND (AZY<=20) then AZY:=20;
  if (AZY>20) AND (AZY<=30) then AZY:=30;
  if (AZY>30) AND (AZY<=40) then AZY:=40;
  if (AZY>40) AND (AZY<=50) then AZY:=50;
  if (AZY>50) AND (AZY<=60) then AZY:=60;
  if (AZY>60) AND (AZY<=70) then AZY:=70;
  if (AZY>70) AND (AZY<=80) then AZY:=80;
  if (AZY>80) AND (AZY<=90) then AZY:=90;
  if (AZY>90) AND (AZY<=100) then AZY:=100;
  if (AZY>100) AND (AZY<=110) then AZY:=110;
  if (AZY>110) AND (AZY<=120) then AZY:=120;
  if (AZY>120) AND (AZY<=130) then AZY:=130;
  if (AZY>130) AND (AZY<=140) then AZY:=140;
  if (AZY>140) AND (AZY<=150) then AZY:=150;
  if (AZY>150) AND (AZY<=160) then AZY:=160;
  if (AZY>160) AND (AZY<=170) then AZY:=170;
  if (AZY>170) AND (AZY<=180) then AZY:=180;

  WebLabel2.Caption:= 'Kąt = '+FloattoStr(KAT)+' st.';

  if KAT=0 then DIC2:='Bok0.png';

  if (KAT>0) AND (KAT<=10) then begin
    if WebLabel5.Caption='N' then DIC2:='Bok10N.png'; end;
  if (KAT>0) AND (KAT<=10) then begin
    if WebLabel5.Caption='S' then DIC2:='Bok10S.png'; end;

  if (KAT>10) AND (KAT<=20) then begin
    if WebLabel5.Caption='N' then DIC2:='Bok20N.png'; end;
  if (KAT>10) AND (KAT<=20) then begin
    if WebLabel5.Caption='S' then DIC2:='Bok20S.png'; end;

  if (KAT>20) AND (KAT<=30) then begin
    if WebLabel5.Caption='N' then DIC2:='Bok30N.png'; end;
  if (KAT>20) AND (KAT<=30) then begin
    if WebLabel5.Caption='S' then DIC2:='Bok30S.png'; end;

  if (KAT>30) AND (KAT<=40) then begin
    if WebLabel5.Caption='N' then DIC2:='Bok40N.png'; end;
  if (KAT>30) AND (KAT<=40) then begin
    if WebLabel5.Caption='S' then DIC2:='Bok40S.png'; end;

  if (KAT>40) AND (KAT<=50) then begin
    if WebLabel5.Caption='N' then DIC2:='Bok50N.png'; end;
  if (KAT>40) AND (KAT<=50) then begin
    if WebLabel5.Caption='S' then DIC2:='Bok50S.png'; end;

  if (KAT>50)AND (KAT<=60) then begin
    if WebLabel5.Caption='N' then DIC2:='Bok60N.png'; end;
  if (KAT>50) AND (KAT<=60) then begin
    if WebLabel5.Caption='S' then DIC2:='Bok60S.png'; end;

  if (KAT>60) AND (KAT<=70) then begin
    if WebLabel5.Caption='N' then DIC2:='Bok70N.png'; end;
  if (KAT>60) AND (KAT<=70) then begin
    if WebLabel5.Caption='S' then DIC2:='Bok70S.png'; end;

  if (KAT>70) AND (KAT<=89) then begin
    if WebLabel5.Caption='N' then DIC2:='Bok80N.png'; end;
  if (KAT>70) AND (KAT<=89) then begin
    if WebLabel5.Caption='S' then DIC2:='Bok80S.png'; end;

  if KAT=90 then begin
      if WebLabel5.Caption='N' then DIC2:='Bok90N.png'; end;
  if KAT=90 then begin
      if WebLabel5.Caption='S' then DIC2:='Bok90S.png'; end;

  WebLabel11.Caption:= 'Azymut = '+FloattoStr(AZY);
   DIC2:='img\'+DIC2;
  Bok.URL:=DIC2;
end;

procedure TForm1.LoadDFMValues;
begin
  inherited LoadDFMValues;

  Bok := TImageControl.Create(Self);
  Rzut := TImageControl.Create(Self);
  WebLabel11 := TLabel.Create(Self);
  Logo := TImageControl.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  WebLabel14 := TLabel.Create(Self);
  WebLabel38 := TLabel.Create(Self);
  FB := TImageControl.Create(Self);
  WebLabel2 := TLabel.Create(Self);
  WebLabel3 := TLabel.Create(Self);
  WebLabel4 := TLabel.Create(Self);
  WebLabel5 := TLabel.Create(Self);
  WebGroupBox3 := TGroupBox.Create(Self);
  WebLabel8 := TLabel.Create(Self);
  WebLabel9 := TLabel.Create(Self);
  WebLabel10 := TLabel.Create(Self);
  WebLabel12 := TLabel.Create(Self);
  WebLabel13 := TLabel.Create(Self);
  WebLabel15 := TLabel.Create(Self);
  WebEdit1 := TEdit.Create(Self);
  WebEdit3 := TEdit.Create(Self);
  WebEdit4 := TEdit.Create(Self);
  WebGroupBox4 := TGroupBox.Create(Self);
  WebLabel20 := TLabel.Create(Self);
  WebLabel21 := TLabel.Create(Self);
  WebLabel22 := TLabel.Create(Self);
  WebLabel23 := TLabel.Create(Self);
  WebLabel6 := TLabel.Create(Self);
  WebLabel7 := TLabel.Create(Self);
  WebComboBox1 := TComboBox.Create(Self);
  WebEdit2 := TEdit.Create(Self);
  WebComboBox2 := TComboBox.Create(Self);
  WebTrackBar1 := TTrackBar.Create(Self);
  WebTrackBar2 := TTrackBar.Create(Self);

  Bok.BeforeLoadDFMValues;
  Rzut.BeforeLoadDFMValues;
  WebLabel11.BeforeLoadDFMValues;
  Logo.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  WebLabel14.BeforeLoadDFMValues;
  WebLabel38.BeforeLoadDFMValues;
  FB.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  WebLabel3.BeforeLoadDFMValues;
  WebLabel4.BeforeLoadDFMValues;
  WebLabel5.BeforeLoadDFMValues;
  WebGroupBox3.BeforeLoadDFMValues;
  WebLabel8.BeforeLoadDFMValues;
  WebLabel9.BeforeLoadDFMValues;
  WebLabel10.BeforeLoadDFMValues;
  WebLabel12.BeforeLoadDFMValues;
  WebLabel13.BeforeLoadDFMValues;
  WebLabel15.BeforeLoadDFMValues;
  WebEdit1.BeforeLoadDFMValues;
  WebEdit3.BeforeLoadDFMValues;
  WebEdit4.BeforeLoadDFMValues;
  WebGroupBox4.BeforeLoadDFMValues;
  WebLabel20.BeforeLoadDFMValues;
  WebLabel21.BeforeLoadDFMValues;
  WebLabel22.BeforeLoadDFMValues;
  WebLabel23.BeforeLoadDFMValues;
  WebLabel6.BeforeLoadDFMValues;
  WebLabel7.BeforeLoadDFMValues;
  WebComboBox1.BeforeLoadDFMValues;
  WebEdit2.BeforeLoadDFMValues;
  WebComboBox2.BeforeLoadDFMValues;
  WebTrackBar1.BeforeLoadDFMValues;
  WebTrackBar2.BeforeLoadDFMValues;
  try
    Name := 'Form1';
    Left := 0;
    Top := 0;
    Width := 600;
    Height := 578;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := 14;
    Font.Name := 'Tahoma';
    Font.Style := [];
    TabOrder := 1;
    Bok.SetParentComponent(Self);
    Bok.Name := 'Bok';
    Bok.Left := 304;
    Bok.Top := 147;
    Bok.Width := 290;
    Bok.Height := 258;
    Bok.ChildOrder := 6;
    Bok.Picture.LoadFromFile('Uzysk.Bok.Picture.png');
    Rzut.SetParentComponent(Self);
    Rzut.Name := 'Rzut';
    Rzut.Left := 8;
    Rzut.Top := 147;
    Rzut.Width := 290;
    Rzut.Height := 258;
    Rzut.ChildOrder := 1;
    Rzut.Picture.LoadFromFile('Uzysk.Rzut.Picture.png');
    WebLabel11.SetParentComponent(Self);
    WebLabel11.Name := 'WebLabel11';
    WebLabel11.Left := 23;
    WebLabel11.Top := 349;
    WebLabel11.Width := 66;
    WebLabel11.Height := 16;
    WebLabel11.Caption := 'Azymut = 0';
    WebLabel11.Font.Charset := DEFAULT_CHARSET;
    WebLabel11.Font.Color := clBlue;
    WebLabel11.Font.Height := -13;
    WebLabel11.Font.Name := 'Tahoma';
    WebLabel11.Font.Style := [];
    WebLabel11.ParentFont := False;
    Logo.SetParentComponent(Self);
    Logo.Name := 'Logo';
    Logo.Left := 1;
    Logo.Top := 32;
    Logo.Width := 229;
    Logo.Height := 87;
    Logo.ChildOrder := 7;
    Logo.Picture.LoadFromFile('Uzysk.Logo.Picture.png');
    WebLabel1.SetParentComponent(Self);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 8;
    WebLabel1.Top := 123;
    WebLabel1.Width := 248;
    WebLabel1.Height := 18;
    WebLabel1.Caption := 'Kalkulator strat uzysk'#243'w energii ';
    WebLabel1.Font.Charset := DEFAULT_CHARSET;
    WebLabel1.Font.Color := clBlue;
    WebLabel1.Font.Height := -15;
    WebLabel1.Font.Name := 'Tahoma';
    WebLabel1.Font.Style := [fsBold];
    WebLabel1.ParentFont := False;
    WebLabel1.Transparent := False;
    WebLabel14.SetParentComponent(Self);
    WebLabel14.Name := 'WebLabel14';
    WebLabel14.Left := 368;
    WebLabel14.Top := 311;
    WebLabel14.Width := 4;
    WebLabel14.Height := 14;
    WebLabel14.WordWrap := True;
    WebLabel38.SetParentComponent(Self);
    WebLabel38.Name := 'WebLabel38';
    WebLabel38.Left := 6;
    WebLabel38.Top := 560;
    WebLabel38.Width := 211;
    WebLabel38.Height := 13;
    WebLabel38.Caption := 'Kalkulator fotowoltaiczny - Pro-Sun (c) 2020';
    WebLabel38.Color := clAqua;
    WebLabel38.Font.Charset := DEFAULT_CHARSET;
    WebLabel38.Font.Color := clWindowText;
    WebLabel38.Font.Height := -11;
    WebLabel38.Font.Name := 'Tahoma';
    WebLabel38.Font.Style := [];
    WebLabel38.ParentFont := False;
    WebLabel38.Transparent := False;
    FB.SetParentComponent(Self);
    FB.Name := 'FB';
    FB.Left := 394;
    FB.Top := 32;
    FB.Width := 198;
    FB.Height := 93;
    FB.ChildOrder := 14;
    FB.Visible := False;
    FB.Picture.LoadFromFile('Uzysk.FB.Picture.jpg');
    WebLabel2.SetParentComponent(Self);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 471;
    WebLabel2.Top := 350;
    WebLabel2.Width := 67;
    WebLabel2.Height := 14;
    WebLabel2.Caption := 'K'#261't = 30 st.';
    WebLabel2.Font.Charset := DEFAULT_CHARSET;
    WebLabel2.Font.Color := clYellow;
    WebLabel2.Font.Height := -12;
    WebLabel2.Font.Name := 'Tahoma';
    WebLabel2.Font.Style := [];
    WebLabel2.ParentFont := False;
    WebLabel3.SetParentComponent(Self);
    WebLabel3.Name := 'WebLabel3';
    WebLabel3.Left := 311;
    WebLabel3.Top := 411;
    WebLabel3.Width := 115;
    WebLabel3.Height := 14;
    WebLabel3.Caption := 'K'#261't nachylenia dachu';
    WebLabel3.Font.Charset := DEFAULT_CHARSET;
    WebLabel3.Font.Color := clWindowText;
    WebLabel3.Font.Height := -12;
    WebLabel3.Font.Name := 'Tahoma';
    WebLabel3.Font.Style := [];
    WebLabel3.ParentFont := False;
    WebLabel4.SetParentComponent(Self);
    WebLabel4.Name := 'WebLabel4';
    WebLabel4.Left := 8;
    WebLabel4.Top := 411;
    WebLabel4.Width := 41;
    WebLabel4.Height := 14;
    WebLabel4.Caption := 'Azymut';
    WebLabel4.Font.Charset := DEFAULT_CHARSET;
    WebLabel4.Font.Color := clWindowText;
    WebLabel4.Font.Height := -12;
    WebLabel4.Font.Name := 'Tahoma';
    WebLabel4.Font.Style := [];
    WebLabel4.ParentFont := False;
    WebLabel5.SetParentComponent(Self);
    WebLabel5.Name := 'WebLabel5';
    WebLabel5.Left := 279;
    WebLabel5.Top := 105;
    WebLabel5.Width := 7;
    WebLabel5.Height := 14;
    WebLabel5.Caption := 'S';
    WebLabel5.Visible := False;
    WebGroupBox3.SetParentComponent(Self);
    WebGroupBox3.Name := 'WebGroupBox3';
    WebGroupBox3.Left := 7;
    WebGroupBox3.Top := 452;
    WebGroupBox3.Width := 287;
    WebGroupBox3.Height := 99;
    WebGroupBox3.Caption := 'Instalacja 1 kWp ';
    WebGroupBox3.ChildOrder := 2;
    WebGroupBox3.Color := clMoneyGreen;
    WebGroupBox3.Font.Charset := DEFAULT_CHARSET;
    WebGroupBox3.Font.Color := clWindowText;
    WebGroupBox3.Font.Height := -12;
    WebGroupBox3.Font.Name := 'Tahoma';
    WebGroupBox3.Font.Style := [];
    WebGroupBox3.ParentFont := False;
    WebLabel8.SetParentComponent(WebGroupBox3);
    WebLabel8.Name := 'WebLabel8';
    WebLabel8.Left := 10;
    WebLabel8.Top := 24;
    WebLabel8.Width := 157;
    WebLabel8.Height := 14;
    WebLabel8.Caption := 'Moc instalacji fotowoltaicznej';
    WebLabel8.Font.Charset := DEFAULT_CHARSET;
    WebLabel8.Font.Color := clWindowText;
    WebLabel8.Font.Height := -12;
    WebLabel8.Font.Name := 'Tahoma';
    WebLabel8.Font.Style := [];
    WebLabel8.ParentFont := False;
    WebLabel9.SetParentComponent(WebGroupBox3);
    WebLabel9.Name := 'WebLabel9';
    WebLabel9.Left := 230;
    WebLabel9.Top := 24;
    WebLabel9.Width := 25;
    WebLabel9.Height := 14;
    WebLabel9.Caption := 'kWp';
    WebLabel9.Font.Charset := DEFAULT_CHARSET;
    WebLabel9.Font.Color := clWindowText;
    WebLabel9.Font.Height := -12;
    WebLabel9.Font.Name := 'Tahoma';
    WebLabel9.Font.Style := [];
    WebLabel9.ParentFont := False;
    WebLabel10.SetParentComponent(WebGroupBox3);
    WebLabel10.Name := 'WebLabel10';
    WebLabel10.Left := 230;
    WebLabel10.Top := 49;
    WebLabel10.Width := 48;
    WebLabel10.Height := 14;
    WebLabel10.Caption := 'kW/kWp';
    WebLabel10.Font.Charset := DEFAULT_CHARSET;
    WebLabel10.Font.Color := clWindowText;
    WebLabel10.Font.Height := -12;
    WebLabel10.Font.Name := 'Tahoma';
    WebLabel10.Font.Style := [];
    WebLabel10.ParentFont := False;
    WebLabel12.SetParentComponent(WebGroupBox3);
    WebLabel12.Name := 'WebLabel12';
    WebLabel12.Left := 10;
    WebLabel12.Top := 49;
    WebLabel12.Width := 137;
    WebLabel12.Height := 14;
    WebLabel12.Caption := 'Charakterystyka lokalizacji';
    WebLabel12.Font.Charset := DEFAULT_CHARSET;
    WebLabel12.Font.Color := clWindowText;
    WebLabel12.Font.Height := -12;
    WebLabel12.Font.Name := 'Tahoma';
    WebLabel12.Font.Style := [];
    WebLabel12.ParentFont := False;
    WebLabel13.SetParentComponent(WebGroupBox3);
    WebLabel13.Name := 'WebLabel13';
    WebLabel13.Left := 230;
    WebLabel13.Top := 74;
    WebLabel13.Width := 28;
    WebLabel13.Height := 14;
    WebLabel13.Caption := 'MWh';
    WebLabel13.Font.Charset := DEFAULT_CHARSET;
    WebLabel13.Font.Color := clWindowText;
    WebLabel13.Font.Height := -12;
    WebLabel13.Font.Name := 'Tahoma';
    WebLabel13.Font.Style := [];
    WebLabel13.ParentFont := False;
    WebLabel15.SetParentComponent(WebGroupBox3);
    WebLabel15.Name := 'WebLabel15';
    WebLabel15.Left := 10;
    WebLabel15.Top := 74;
    WebLabel15.Width := 97;
    WebLabel15.Height := 14;
    WebLabel15.Caption := 'Uzysk w skali roku';
    WebLabel15.Font.Charset := DEFAULT_CHARSET;
    WebLabel15.Font.Color := clWindowText;
    WebLabel15.Font.Height := -12;
    WebLabel15.Font.Name := 'Tahoma';
    WebLabel15.Font.Style := [];
    WebLabel15.ParentFont := False;
    WebEdit1.SetParentComponent(WebGroupBox3);
    WebEdit1.Name := 'WebEdit1';
    WebEdit1.Left := 180;
    WebEdit1.Top := 23;
    WebEdit1.Width := 46;
    WebEdit1.Height := 19;
    WebEdit1.ChildOrder := 5;
    WebEdit1.Enabled := False;
    WebEdit1.Text := '1';
    WebEdit3.SetParentComponent(WebGroupBox3);
    WebEdit3.Name := 'WebEdit3';
    WebEdit3.Left := 180;
    WebEdit3.Top := 48;
    WebEdit3.Width := 46;
    WebEdit3.Height := 19;
    WebEdit3.ChildOrder := 5;
    WebEdit3.Enabled := False;
    WebEdit3.Text := '1000';
    WebEdit4.SetParentComponent(WebGroupBox3);
    WebEdit4.Name := 'WebEdit4';
    WebEdit4.Left := 180;
    WebEdit4.Top := 73;
    WebEdit4.Width := 46;
    WebEdit4.Height := 19;
    WebEdit4.ChildOrder := 5;
    WebEdit4.Enabled := False;
    WebEdit4.Text := '1';
    WebGroupBox4.SetParentComponent(Self);
    WebGroupBox4.Name := 'WebGroupBox4';
    WebGroupBox4.Left := 300;
    WebGroupBox4.Top := 452;
    WebGroupBox4.Width := 289;
    WebGroupBox4.Height := 98;
    WebGroupBox4.Caption := 'Instsalacja fotowltaiczna ';
    WebGroupBox4.ChildOrder := 3;
    WebGroupBox4.Color := clSkyBlue;
    WebGroupBox4.Font.Charset := DEFAULT_CHARSET;
    WebGroupBox4.Font.Color := clWindowText;
    WebGroupBox4.Font.Height := -12;
    WebGroupBox4.Font.Name := 'Tahoma';
    WebGroupBox4.Font.Style := [];
    WebGroupBox4.ParentFont := False;
    WebLabel20.SetParentComponent(WebGroupBox4);
    WebLabel20.Name := 'WebLabel20';
    WebLabel20.Left := 10;
    WebLabel20.Top := 21;
    WebLabel20.Width := 89;
    WebLabel20.Height := 14;
    WebLabel20.Caption := 'Moc instalacji PV';
    WebLabel20.Font.Charset := DEFAULT_CHARSET;
    WebLabel20.Font.Color := clWindowText;
    WebLabel20.Font.Height := -12;
    WebLabel20.Font.Name := 'Tahoma';
    WebLabel20.Font.Style := [];
    WebLabel20.ParentFont := False;
    WebLabel21.SetParentComponent(WebGroupBox4);
    WebLabel21.Name := 'WebLabel21';
    WebLabel21.Left := 228;
    WebLabel21.Top := 21;
    WebLabel21.Width := 25;
    WebLabel21.Height := 14;
    WebLabel21.Caption := 'kWp';
    WebLabel21.Font.Charset := DEFAULT_CHARSET;
    WebLabel21.Font.Color := clWindowText;
    WebLabel21.Font.Height := -12;
    WebLabel21.Font.Name := 'Tahoma';
    WebLabel21.Font.Style := [];
    WebLabel21.ParentFont := False;
    WebLabel22.SetParentComponent(WebGroupBox4);
    WebLabel22.Name := 'WebLabel22';
    WebLabel22.Left := 228;
    WebLabel22.Top := 46;
    WebLabel22.Width := 48;
    WebLabel22.Height := 14;
    WebLabel22.Caption := 'kW/kWp';
    WebLabel22.Font.Charset := DEFAULT_CHARSET;
    WebLabel22.Font.Color := clWindowText;
    WebLabel22.Font.Height := -12;
    WebLabel22.Font.Name := 'Tahoma';
    WebLabel22.Font.Style := [];
    WebLabel22.ParentFont := False;
    WebLabel23.SetParentComponent(WebGroupBox4);
    WebLabel23.Name := 'WebLabel23';
    WebLabel23.Left := 10;
    WebLabel23.Top := 46;
    WebLabel23.Width := 87;
    WebLabel23.Height := 14;
    WebLabel23.Caption := 'Moc specyficzna';
    WebLabel23.Font.Charset := DEFAULT_CHARSET;
    WebLabel23.Font.Color := clWindowText;
    WebLabel23.Font.Height := -12;
    WebLabel23.Font.Name := 'Tahoma';
    WebLabel23.Font.Style := [];
    WebLabel23.ParentFont := False;
    WebLabel6.SetParentComponent(WebGroupBox4);
    WebLabel6.Name := 'WebLabel6';
    WebLabel6.Left := 10;
    WebLabel6.Top := 72;
    WebLabel6.Width := 97;
    WebLabel6.Height := 14;
    WebLabel6.Caption := 'Uzysk w skali roku';
    WebLabel6.Font.Charset := DEFAULT_CHARSET;
    WebLabel6.Font.Color := clWindowText;
    WebLabel6.Font.Height := -12;
    WebLabel6.Font.Name := 'Tahoma';
    WebLabel6.Font.Style := [];
    WebLabel6.ParentFont := False;
    WebLabel7.SetParentComponent(WebGroupBox4);
    WebLabel7.Name := 'WebLabel7';
    WebLabel7.Left := 228;
    WebLabel7.Top := 72;
    WebLabel7.Width := 28;
    WebLabel7.Height := 14;
    WebLabel7.Caption := 'MWh';
    WebLabel7.Font.Charset := DEFAULT_CHARSET;
    WebLabel7.Font.Color := clWindowText;
    WebLabel7.Font.Height := -12;
    WebLabel7.Font.Name := 'Tahoma';
    WebLabel7.Font.Style := [];
    WebLabel7.ParentFont := False;
    WebComboBox1.SetParentComponent(WebGroupBox4);
    WebComboBox1.Name := 'WebComboBox1';
    WebComboBox1.Left := 165;
    WebComboBox1.Top := 18;
    WebComboBox1.Width := 57;
    WebComboBox1.Height := 22;
    WebComboBox1.Color := clYellow;
    WebComboBox1.Text := '1';
    SetEvent(WebComboBox1, Self, 'OnChange', 'WebComboBox1Change');
    WebComboBox1.ItemIndex := 0;
    WebComboBox1.Items.BeginUpdate;
    try
      WebComboBox1.Items.Clear;
      WebComboBox1.Items.Add('1');
      WebComboBox1.Items.Add('1,1');
      WebComboBox1.Items.Add('1,2');
      WebComboBox1.Items.Add('1,3');
      WebComboBox1.Items.Add('1,4');
      WebComboBox1.Items.Add('1,5');
      WebComboBox1.Items.Add('1,6');
      WebComboBox1.Items.Add('1,7');
      WebComboBox1.Items.Add('1,8');
      WebComboBox1.Items.Add('1,9');
      WebComboBox1.Items.Add('2');
      WebComboBox1.Items.Add('2,1');
      WebComboBox1.Items.Add('2,2');
      WebComboBox1.Items.Add('2,3');
      WebComboBox1.Items.Add('2,4');
      WebComboBox1.Items.Add('2,5');
      WebComboBox1.Items.Add('2,6');
      WebComboBox1.Items.Add('2,7');
      WebComboBox1.Items.Add('2,8');
      WebComboBox1.Items.Add('2,9');
      WebComboBox1.Items.Add('3');
      WebComboBox1.Items.Add('3,1');
      WebComboBox1.Items.Add('3,2');
      WebComboBox1.Items.Add('3,3');
      WebComboBox1.Items.Add('3,4');
      WebComboBox1.Items.Add('3,5');
      WebComboBox1.Items.Add('3,6');
      WebComboBox1.Items.Add('3,7');
      WebComboBox1.Items.Add('3,8');
      WebComboBox1.Items.Add('3,9');
      WebComboBox1.Items.Add('4');
      WebComboBox1.Items.Add('4,1');
      WebComboBox1.Items.Add('4,2');
      WebComboBox1.Items.Add('4,3');
      WebComboBox1.Items.Add('4,4');
      WebComboBox1.Items.Add('4,5');
      WebComboBox1.Items.Add('4,6');
      WebComboBox1.Items.Add('4,7');
      WebComboBox1.Items.Add('4,8');
      WebComboBox1.Items.Add('4,9');
      WebComboBox1.Items.Add('5');
      WebComboBox1.Items.Add('5,1');
      WebComboBox1.Items.Add('5,2');
      WebComboBox1.Items.Add('5,3');
      WebComboBox1.Items.Add('5,4');
      WebComboBox1.Items.Add('5,5');
      WebComboBox1.Items.Add('5,6');
      WebComboBox1.Items.Add('5,7');
      WebComboBox1.Items.Add('5,8');
      WebComboBox1.Items.Add('5,9');
      WebComboBox1.Items.Add('6');
      WebComboBox1.Items.Add('6,1');
      WebComboBox1.Items.Add('6,2');
      WebComboBox1.Items.Add('6,3');
      WebComboBox1.Items.Add('6,4');
      WebComboBox1.Items.Add('6,5');
      WebComboBox1.Items.Add('6,6');
      WebComboBox1.Items.Add('6,7');
      WebComboBox1.Items.Add('6,8');
      WebComboBox1.Items.Add('6,9');
      WebComboBox1.Items.Add('7');
      WebComboBox1.Items.Add('7,1');
      WebComboBox1.Items.Add('7,2');
      WebComboBox1.Items.Add('7,3');
      WebComboBox1.Items.Add('7,4');
      WebComboBox1.Items.Add('7,5');
      WebComboBox1.Items.Add('7,6');
      WebComboBox1.Items.Add('7,7');
      WebComboBox1.Items.Add('7,8');
      WebComboBox1.Items.Add('7,9');
      WebComboBox1.Items.Add('8');
      WebComboBox1.Items.Add('8,1');
      WebComboBox1.Items.Add('8,2');
      WebComboBox1.Items.Add('8,3');
      WebComboBox1.Items.Add('8,4');
      WebComboBox1.Items.Add('8,5');
      WebComboBox1.Items.Add('8,6');
      WebComboBox1.Items.Add('8,7');
      WebComboBox1.Items.Add('8,8');
      WebComboBox1.Items.Add('8,9');
      WebComboBox1.Items.Add('9');
      WebComboBox1.Items.Add('9,1');
      WebComboBox1.Items.Add('9,2');
      WebComboBox1.Items.Add('9,3');
      WebComboBox1.Items.Add('9,4');
      WebComboBox1.Items.Add('9,5');
      WebComboBox1.Items.Add('9,6');
      WebComboBox1.Items.Add('9,7');
      WebComboBox1.Items.Add('9,8');
      WebComboBox1.Items.Add('9,9');
      WebComboBox1.Items.Add('10');
      WebComboBox1.Items.Add('10,1');
      WebComboBox1.Items.Add('10,2');
      WebComboBox1.Items.Add('10,3');
      WebComboBox1.Items.Add('10,4');
      WebComboBox1.Items.Add('10,5');
      WebComboBox1.Items.Add('10,6');
      WebComboBox1.Items.Add('10,7');
      WebComboBox1.Items.Add('10,8');
      WebComboBox1.Items.Add('10,9');
      WebComboBox1.Items.Add('11');
      WebComboBox1.Items.Add('11,1');
      WebComboBox1.Items.Add('11,2');
      WebComboBox1.Items.Add('11,3');
      WebComboBox1.Items.Add('11,4');
      WebComboBox1.Items.Add('11,5');
      WebComboBox1.Items.Add('11,6');
      WebComboBox1.Items.Add('11,7');
      WebComboBox1.Items.Add('11,8');
      WebComboBox1.Items.Add('11,9');
      WebComboBox1.Items.Add('12');
      WebComboBox1.Items.Add('12,1');
      WebComboBox1.Items.Add('12,2');
      WebComboBox1.Items.Add('12,3');
      WebComboBox1.Items.Add('12,4');
      WebComboBox1.Items.Add('12,5');
      WebComboBox1.Items.Add('12,6');
      WebComboBox1.Items.Add('12,7');
      WebComboBox1.Items.Add('12,8');
      WebComboBox1.Items.Add('12,9');
      WebComboBox1.Items.Add('13');
      WebComboBox1.Items.Add('13,1');
      WebComboBox1.Items.Add('13,2');
      WebComboBox1.Items.Add('13,3');
      WebComboBox1.Items.Add('13,4');
      WebComboBox1.Items.Add('13,5');
      WebComboBox1.Items.Add('13,6');
      WebComboBox1.Items.Add('13,7');
      WebComboBox1.Items.Add('13,8');
      WebComboBox1.Items.Add('13,9');
      WebComboBox1.Items.Add('14');
      WebComboBox1.Items.Add('14,1');
      WebComboBox1.Items.Add('14,2');
      WebComboBox1.Items.Add('14,3');
      WebComboBox1.Items.Add('14,4');
      WebComboBox1.Items.Add('14,5');
      WebComboBox1.Items.Add('14,6');
      WebComboBox1.Items.Add('14,7');
      WebComboBox1.Items.Add('14,8');
      WebComboBox1.Items.Add('14,9');
      WebComboBox1.Items.Add('15');
      WebComboBox1.Items.Add('15,1');
      WebComboBox1.Items.Add('15,2');
      WebComboBox1.Items.Add('15,3');
      WebComboBox1.Items.Add('15,4');
      WebComboBox1.Items.Add('15,5');
      WebComboBox1.Items.Add('15,6');
      WebComboBox1.Items.Add('15,7');
      WebComboBox1.Items.Add('15,8');
      WebComboBox1.Items.Add('15,9');
      WebComboBox1.Items.Add('16');
      WebComboBox1.Items.Add('16,1');
      WebComboBox1.Items.Add('16,2');
      WebComboBox1.Items.Add('16,3');
      WebComboBox1.Items.Add('16,4');
      WebComboBox1.Items.Add('16,5');
      WebComboBox1.Items.Add('16,6');
      WebComboBox1.Items.Add('16,7');
      WebComboBox1.Items.Add('16,8');
      WebComboBox1.Items.Add('16,9');
      WebComboBox1.Items.Add('17');
      WebComboBox1.Items.Add('17,1');
      WebComboBox1.Items.Add('17,2');
      WebComboBox1.Items.Add('17,3');
      WebComboBox1.Items.Add('17,4');
      WebComboBox1.Items.Add('17,5');
      WebComboBox1.Items.Add('17,6');
      WebComboBox1.Items.Add('17,7');
      WebComboBox1.Items.Add('17,8');
      WebComboBox1.Items.Add('17,9');
      WebComboBox1.Items.Add('18');
      WebComboBox1.Items.Add('18,1');
      WebComboBox1.Items.Add('18,2');
      WebComboBox1.Items.Add('18,3');
      WebComboBox1.Items.Add('18,4');
      WebComboBox1.Items.Add('18,5');
      WebComboBox1.Items.Add('18,6');
      WebComboBox1.Items.Add('18,7');
      WebComboBox1.Items.Add('18,8');
      WebComboBox1.Items.Add('18,9');
      WebComboBox1.Items.Add('19');
      WebComboBox1.Items.Add('19,1');
      WebComboBox1.Items.Add('19,2');
      WebComboBox1.Items.Add('19,3');
      WebComboBox1.Items.Add('19,4');
      WebComboBox1.Items.Add('19,5');
      WebComboBox1.Items.Add('19,6');
      WebComboBox1.Items.Add('19,7');
      WebComboBox1.Items.Add('19,8');
      WebComboBox1.Items.Add('19,9');
      WebComboBox1.Items.Add('20');
      WebComboBox1.Items.Add('20,1');
      WebComboBox1.Items.Add('20,2');
      WebComboBox1.Items.Add('20,3');
      WebComboBox1.Items.Add('20,4');
      WebComboBox1.Items.Add('20,5');
      WebComboBox1.Items.Add('20,6');
      WebComboBox1.Items.Add('20,7');
      WebComboBox1.Items.Add('20,8');
      WebComboBox1.Items.Add('20,9');
      WebComboBox1.Items.Add('21');
      WebComboBox1.Items.Add('21,1');
      WebComboBox1.Items.Add('21,2');
      WebComboBox1.Items.Add('21,3');
      WebComboBox1.Items.Add('21,4');
      WebComboBox1.Items.Add('21,5');
      WebComboBox1.Items.Add('21,6');
      WebComboBox1.Items.Add('21,7');
      WebComboBox1.Items.Add('21,8');
      WebComboBox1.Items.Add('21,9');
      WebComboBox1.Items.Add('22');
      WebComboBox1.Items.Add('22,1');
      WebComboBox1.Items.Add('22,2');
      WebComboBox1.Items.Add('22,3');
      WebComboBox1.Items.Add('22,4');
      WebComboBox1.Items.Add('22,5');
      WebComboBox1.Items.Add('22,6');
      WebComboBox1.Items.Add('22,7');
      WebComboBox1.Items.Add('22,8');
      WebComboBox1.Items.Add('22,9');
      WebComboBox1.Items.Add('23');
      WebComboBox1.Items.Add('23,1');
      WebComboBox1.Items.Add('23,2');
      WebComboBox1.Items.Add('23,3');
      WebComboBox1.Items.Add('23,4');
      WebComboBox1.Items.Add('23,5');
      WebComboBox1.Items.Add('23,6');
      WebComboBox1.Items.Add('23,7');
      WebComboBox1.Items.Add('23,8');
      WebComboBox1.Items.Add('23,9');
      WebComboBox1.Items.Add('24');
      WebComboBox1.Items.Add('24,1');
      WebComboBox1.Items.Add('24,2');
      WebComboBox1.Items.Add('24,3');
      WebComboBox1.Items.Add('24,4');
      WebComboBox1.Items.Add('24,5');
      WebComboBox1.Items.Add('24,6');
      WebComboBox1.Items.Add('24,7');
      WebComboBox1.Items.Add('24,8');
      WebComboBox1.Items.Add('24,9');
      WebComboBox1.Items.Add('25');
      WebComboBox1.Items.Add('25,1');
      WebComboBox1.Items.Add('25,2');
      WebComboBox1.Items.Add('25,3');
      WebComboBox1.Items.Add('25,4');
      WebComboBox1.Items.Add('25,5');
      WebComboBox1.Items.Add('25,6');
      WebComboBox1.Items.Add('25,7');
      WebComboBox1.Items.Add('25,8');
      WebComboBox1.Items.Add('25,9');
      WebComboBox1.Items.Add('26');
      WebComboBox1.Items.Add('26,1');
      WebComboBox1.Items.Add('26,2');
      WebComboBox1.Items.Add('26,3');
      WebComboBox1.Items.Add('26,4');
      WebComboBox1.Items.Add('26,5');
      WebComboBox1.Items.Add('26,6');
      WebComboBox1.Items.Add('26,7');
      WebComboBox1.Items.Add('26,8');
      WebComboBox1.Items.Add('26,9');
      WebComboBox1.Items.Add('27');
      WebComboBox1.Items.Add('27,1');
      WebComboBox1.Items.Add('27,2');
      WebComboBox1.Items.Add('27,3');
      WebComboBox1.Items.Add('27,4');
      WebComboBox1.Items.Add('27,5');
      WebComboBox1.Items.Add('27,6');
      WebComboBox1.Items.Add('27,7');
      WebComboBox1.Items.Add('27,8');
      WebComboBox1.Items.Add('27,9');
      WebComboBox1.Items.Add('28');
      WebComboBox1.Items.Add('28,1');
      WebComboBox1.Items.Add('28,2');
      WebComboBox1.Items.Add('28,3');
      WebComboBox1.Items.Add('28,4');
      WebComboBox1.Items.Add('28,5');
      WebComboBox1.Items.Add('28,6');
      WebComboBox1.Items.Add('28,7');
      WebComboBox1.Items.Add('28,8');
      WebComboBox1.Items.Add('28,9');
      WebComboBox1.Items.Add('29');
      WebComboBox1.Items.Add('29,1');
      WebComboBox1.Items.Add('29,2');
      WebComboBox1.Items.Add('29,3');
      WebComboBox1.Items.Add('29,4');
      WebComboBox1.Items.Add('29,5');
      WebComboBox1.Items.Add('29,6');
      WebComboBox1.Items.Add('29,7');
      WebComboBox1.Items.Add('29,8');
      WebComboBox1.Items.Add('29,9');
      WebComboBox1.Items.Add('30');
      WebComboBox1.Items.Add('30,1');
      WebComboBox1.Items.Add('30,2');
      WebComboBox1.Items.Add('30,3');
      WebComboBox1.Items.Add('30,4');
      WebComboBox1.Items.Add('30,5');
      WebComboBox1.Items.Add('30,6');
      WebComboBox1.Items.Add('30,7');
      WebComboBox1.Items.Add('30,8');
      WebComboBox1.Items.Add('30,9');
      WebComboBox1.Items.Add('31');
      WebComboBox1.Items.Add('31,1');
      WebComboBox1.Items.Add('31,2');
      WebComboBox1.Items.Add('31,3');
      WebComboBox1.Items.Add('31,4');
      WebComboBox1.Items.Add('31,5');
      WebComboBox1.Items.Add('31,6');
      WebComboBox1.Items.Add('31,7');
      WebComboBox1.Items.Add('31,8');
      WebComboBox1.Items.Add('31,9');
      WebComboBox1.Items.Add('32');
      WebComboBox1.Items.Add('32,1');
      WebComboBox1.Items.Add('32,2');
      WebComboBox1.Items.Add('32,3');
      WebComboBox1.Items.Add('32,4');
      WebComboBox1.Items.Add('32,5');
      WebComboBox1.Items.Add('32,6');
      WebComboBox1.Items.Add('32,7');
      WebComboBox1.Items.Add('32,8');
      WebComboBox1.Items.Add('32,9');
      WebComboBox1.Items.Add('33');
      WebComboBox1.Items.Add('33,1');
      WebComboBox1.Items.Add('33,2');
      WebComboBox1.Items.Add('33,3');
      WebComboBox1.Items.Add('33,4');
      WebComboBox1.Items.Add('33,5');
      WebComboBox1.Items.Add('33,6');
      WebComboBox1.Items.Add('33,7');
      WebComboBox1.Items.Add('33,8');
      WebComboBox1.Items.Add('33,9');
      WebComboBox1.Items.Add('34');
      WebComboBox1.Items.Add('34,1');
      WebComboBox1.Items.Add('34,2');
      WebComboBox1.Items.Add('34,3');
      WebComboBox1.Items.Add('34,4');
      WebComboBox1.Items.Add('34,5');
      WebComboBox1.Items.Add('34,6');
      WebComboBox1.Items.Add('34,7');
      WebComboBox1.Items.Add('34,8');
      WebComboBox1.Items.Add('34,9');
      WebComboBox1.Items.Add('35');
      WebComboBox1.Items.Add('35,1');
      WebComboBox1.Items.Add('35,2');
      WebComboBox1.Items.Add('35,3');
      WebComboBox1.Items.Add('35,4');
      WebComboBox1.Items.Add('35,5');
      WebComboBox1.Items.Add('35,6');
      WebComboBox1.Items.Add('35,7');
      WebComboBox1.Items.Add('35,8');
      WebComboBox1.Items.Add('35,9');
      WebComboBox1.Items.Add('36');
      WebComboBox1.Items.Add('36,1');
      WebComboBox1.Items.Add('36,2');
      WebComboBox1.Items.Add('36,3');
      WebComboBox1.Items.Add('36,4');
      WebComboBox1.Items.Add('36,5');
      WebComboBox1.Items.Add('36,6');
      WebComboBox1.Items.Add('36,7');
      WebComboBox1.Items.Add('36,8');
      WebComboBox1.Items.Add('36,9');
      WebComboBox1.Items.Add('37');
      WebComboBox1.Items.Add('37,1');
      WebComboBox1.Items.Add('37,2');
      WebComboBox1.Items.Add('37,3');
      WebComboBox1.Items.Add('37,4');
      WebComboBox1.Items.Add('37,5');
      WebComboBox1.Items.Add('37,6');
      WebComboBox1.Items.Add('37,7');
      WebComboBox1.Items.Add('37,8');
      WebComboBox1.Items.Add('37,9');
      WebComboBox1.Items.Add('38');
      WebComboBox1.Items.Add('38,1');
      WebComboBox1.Items.Add('38,2');
      WebComboBox1.Items.Add('38,3');
      WebComboBox1.Items.Add('38,4');
      WebComboBox1.Items.Add('38,5');
      WebComboBox1.Items.Add('38,6');
      WebComboBox1.Items.Add('38,7');
      WebComboBox1.Items.Add('38,8');
      WebComboBox1.Items.Add('38,9');
      WebComboBox1.Items.Add('39');
      WebComboBox1.Items.Add('39,1');
      WebComboBox1.Items.Add('39,2');
      WebComboBox1.Items.Add('39,3');
      WebComboBox1.Items.Add('39,4');
      WebComboBox1.Items.Add('39,5');
      WebComboBox1.Items.Add('39,6');
      WebComboBox1.Items.Add('39,7');
      WebComboBox1.Items.Add('39,8');
      WebComboBox1.Items.Add('39,9');
      WebComboBox1.Items.Add('40');
      WebComboBox1.Items.Add('40,1');
      WebComboBox1.Items.Add('40,2');
      WebComboBox1.Items.Add('40,3');
      WebComboBox1.Items.Add('40,4');
      WebComboBox1.Items.Add('40,5');
      WebComboBox1.Items.Add('40,6');
      WebComboBox1.Items.Add('40,7');
      WebComboBox1.Items.Add('40,8');
      WebComboBox1.Items.Add('40,9');
      WebComboBox1.Items.Add('41');
      WebComboBox1.Items.Add('41,1');
      WebComboBox1.Items.Add('41,2');
      WebComboBox1.Items.Add('41,3');
      WebComboBox1.Items.Add('41,4');
      WebComboBox1.Items.Add('41,5');
      WebComboBox1.Items.Add('41,6');
      WebComboBox1.Items.Add('41,7');
      WebComboBox1.Items.Add('41,8');
      WebComboBox1.Items.Add('41,9');
      WebComboBox1.Items.Add('42');
      WebComboBox1.Items.Add('42,1');
      WebComboBox1.Items.Add('42,2');
      WebComboBox1.Items.Add('42,3');
      WebComboBox1.Items.Add('42,4');
      WebComboBox1.Items.Add('42,5');
      WebComboBox1.Items.Add('42,6');
      WebComboBox1.Items.Add('42,7');
      WebComboBox1.Items.Add('42,8');
      WebComboBox1.Items.Add('42,9');
      WebComboBox1.Items.Add('43');
      WebComboBox1.Items.Add('43,1');
      WebComboBox1.Items.Add('43,2');
      WebComboBox1.Items.Add('43,3');
      WebComboBox1.Items.Add('43,4');
      WebComboBox1.Items.Add('43,5');
      WebComboBox1.Items.Add('43,6');
      WebComboBox1.Items.Add('43,7');
      WebComboBox1.Items.Add('43,8');
      WebComboBox1.Items.Add('43,9');
      WebComboBox1.Items.Add('44');
      WebComboBox1.Items.Add('44,1');
      WebComboBox1.Items.Add('44,2');
      WebComboBox1.Items.Add('44,3');
      WebComboBox1.Items.Add('44,4');
      WebComboBox1.Items.Add('44,5');
      WebComboBox1.Items.Add('44,6');
      WebComboBox1.Items.Add('44,7');
      WebComboBox1.Items.Add('44,8');
      WebComboBox1.Items.Add('44,9');
      WebComboBox1.Items.Add('45');
      WebComboBox1.Items.Add('45,1');
      WebComboBox1.Items.Add('45,2');
      WebComboBox1.Items.Add('45,3');
      WebComboBox1.Items.Add('45,4');
      WebComboBox1.Items.Add('45,5');
      WebComboBox1.Items.Add('45,6');
      WebComboBox1.Items.Add('45,7');
      WebComboBox1.Items.Add('45,8');
      WebComboBox1.Items.Add('45,9');
      WebComboBox1.Items.Add('46');
      WebComboBox1.Items.Add('46,1');
      WebComboBox1.Items.Add('46,2');
      WebComboBox1.Items.Add('46,3');
      WebComboBox1.Items.Add('46,4');
      WebComboBox1.Items.Add('46,5');
      WebComboBox1.Items.Add('46,6');
      WebComboBox1.Items.Add('46,7');
      WebComboBox1.Items.Add('46,8');
      WebComboBox1.Items.Add('46,9');
      WebComboBox1.Items.Add('47');
      WebComboBox1.Items.Add('47,1');
      WebComboBox1.Items.Add('47,2');
      WebComboBox1.Items.Add('47,3');
      WebComboBox1.Items.Add('47,4');
      WebComboBox1.Items.Add('47,5');
      WebComboBox1.Items.Add('47,6');
      WebComboBox1.Items.Add('47,7');
      WebComboBox1.Items.Add('47,8');
      WebComboBox1.Items.Add('47,9');
      WebComboBox1.Items.Add('48');
      WebComboBox1.Items.Add('48,1');
      WebComboBox1.Items.Add('48,2');
      WebComboBox1.Items.Add('48,3');
      WebComboBox1.Items.Add('48,4');
      WebComboBox1.Items.Add('48,5');
      WebComboBox1.Items.Add('48,6');
      WebComboBox1.Items.Add('48,7');
      WebComboBox1.Items.Add('48,8');
      WebComboBox1.Items.Add('48,9');
      WebComboBox1.Items.Add('49');
      WebComboBox1.Items.Add('49,1');
      WebComboBox1.Items.Add('49,2');
      WebComboBox1.Items.Add('49,3');
      WebComboBox1.Items.Add('49,4');
      WebComboBox1.Items.Add('49,5');
      WebComboBox1.Items.Add('49,6');
      WebComboBox1.Items.Add('49,7');
      WebComboBox1.Items.Add('49,8');
      WebComboBox1.Items.Add('49,9');
      WebComboBox1.Items.Add('50');
    finally
      WebComboBox1.Items.EndUpdate;
    end;
    WebEdit2.SetParentComponent(WebGroupBox4);
    WebEdit2.Name := 'WebEdit2';
    WebEdit2.Left := 165;
    WebEdit2.Top := 71;
    WebEdit2.Width := 57;
    WebEdit2.Height := 19;
    WebEdit2.ChildOrder := 5;
    WebEdit2.Enabled := False;
    WebEdit2.Text := '1';
    WebComboBox2.SetParentComponent(WebGroupBox4);
    WebComboBox2.Name := 'WebComboBox2';
    WebComboBox2.Left := 165;
    WebComboBox2.Top := 45;
    WebComboBox2.Width := 57;
    WebComboBox2.Height := 22;
    WebComboBox2.Color := clYellow;
    WebComboBox2.Text := '1000';
    SetEvent(WebComboBox2, Self, 'OnChange', 'WebComboBox2Change');
    WebComboBox2.ItemIndex := 50;
    WebComboBox2.Items.BeginUpdate;
    try
      WebComboBox2.Items.Clear;
      WebComboBox2.Items.Add('500');
      WebComboBox2.Items.Add('510');
      WebComboBox2.Items.Add('520');
      WebComboBox2.Items.Add('530');
      WebComboBox2.Items.Add('540');
      WebComboBox2.Items.Add('550');
      WebComboBox2.Items.Add('560');
      WebComboBox2.Items.Add('570');
      WebComboBox2.Items.Add('580');
      WebComboBox2.Items.Add('590');
      WebComboBox2.Items.Add('600');
      WebComboBox2.Items.Add('610');
      WebComboBox2.Items.Add('620');
      WebComboBox2.Items.Add('630');
      WebComboBox2.Items.Add('640');
      WebComboBox2.Items.Add('650');
      WebComboBox2.Items.Add('660');
      WebComboBox2.Items.Add('670');
      WebComboBox2.Items.Add('680');
      WebComboBox2.Items.Add('690');
      WebComboBox2.Items.Add('700');
      WebComboBox2.Items.Add('710');
      WebComboBox2.Items.Add('720');
      WebComboBox2.Items.Add('730');
      WebComboBox2.Items.Add('740');
      WebComboBox2.Items.Add('750');
      WebComboBox2.Items.Add('760');
      WebComboBox2.Items.Add('770');
      WebComboBox2.Items.Add('780');
      WebComboBox2.Items.Add('790');
      WebComboBox2.Items.Add('800');
      WebComboBox2.Items.Add('810');
      WebComboBox2.Items.Add('820');
      WebComboBox2.Items.Add('830');
      WebComboBox2.Items.Add('840');
      WebComboBox2.Items.Add('850');
      WebComboBox2.Items.Add('860');
      WebComboBox2.Items.Add('870');
      WebComboBox2.Items.Add('880');
      WebComboBox2.Items.Add('890');
      WebComboBox2.Items.Add('900');
      WebComboBox2.Items.Add('910');
      WebComboBox2.Items.Add('920');
      WebComboBox2.Items.Add('930');
      WebComboBox2.Items.Add('940');
      WebComboBox2.Items.Add('950');
      WebComboBox2.Items.Add('960');
      WebComboBox2.Items.Add('970');
      WebComboBox2.Items.Add('980');
      WebComboBox2.Items.Add('990');
      WebComboBox2.Items.Add('1000');
      WebComboBox2.Items.Add('1010');
      WebComboBox2.Items.Add('1020');
      WebComboBox2.Items.Add('1030');
      WebComboBox2.Items.Add('1040');
      WebComboBox2.Items.Add('1050');
      WebComboBox2.Items.Add('1060');
      WebComboBox2.Items.Add('1070');
      WebComboBox2.Items.Add('1080');
      WebComboBox2.Items.Add('1090');
      WebComboBox2.Items.Add('1100');
      WebComboBox2.Items.Add('1110');
      WebComboBox2.Items.Add('1120');
      WebComboBox2.Items.Add('1130');
      WebComboBox2.Items.Add('1140');
      WebComboBox2.Items.Add('1150');
      WebComboBox2.Items.Add('1160');
      WebComboBox2.Items.Add('1170');
      WebComboBox2.Items.Add('1180');
      WebComboBox2.Items.Add('1190');
      WebComboBox2.Items.Add('1200');
    finally
      WebComboBox2.Items.EndUpdate;
    end;
    WebTrackBar1.SetParentComponent(Self);
    WebTrackBar1.Name := 'WebTrackBar1';
    WebTrackBar1.Left := 8;
    WebTrackBar1.Top := 426;
    WebTrackBar1.Width := 290;
    WebTrackBar1.Height := 20;
    WebTrackBar1.ChildOrder := 11;
    WebTrackBar1.Max := 180;
    WebTrackBar1.Min := -180;
    WebTrackBar1.Position := 0;
    WebTrackBar1.Role := '';
    SetEvent(WebTrackBar1, Self, 'OnChange', 'WebTrackBar1Change');
    WebTrackBar2.SetParentComponent(Self);
    WebTrackBar2.Name := 'WebTrackBar2';
    WebTrackBar2.Left := 304;
    WebTrackBar2.Top := 426;
    WebTrackBar2.Width := 288;
    WebTrackBar2.Height := 20;
    WebTrackBar2.ChildOrder := 12;
    WebTrackBar2.Max := 90;
    WebTrackBar2.Min := 0;
    WebTrackBar2.Position := 30;
    WebTrackBar2.Role := '';
    SetEvent(WebTrackBar2, Self, 'OnChange', 'WebTrackBar2Change');
  finally
    Bok.AfterLoadDFMValues;
    Rzut.AfterLoadDFMValues;
    WebLabel11.AfterLoadDFMValues;
    Logo.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    WebLabel14.AfterLoadDFMValues;
    WebLabel38.AfterLoadDFMValues;
    FB.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    WebLabel3.AfterLoadDFMValues;
    WebLabel4.AfterLoadDFMValues;
    WebLabel5.AfterLoadDFMValues;
    WebGroupBox3.AfterLoadDFMValues;
    WebLabel8.AfterLoadDFMValues;
    WebLabel9.AfterLoadDFMValues;
    WebLabel10.AfterLoadDFMValues;
    WebLabel12.AfterLoadDFMValues;
    WebLabel13.AfterLoadDFMValues;
    WebLabel15.AfterLoadDFMValues;
    WebEdit1.AfterLoadDFMValues;
    WebEdit3.AfterLoadDFMValues;
    WebEdit4.AfterLoadDFMValues;
    WebGroupBox4.AfterLoadDFMValues;
    WebLabel20.AfterLoadDFMValues;
    WebLabel21.AfterLoadDFMValues;
    WebLabel22.AfterLoadDFMValues;
    WebLabel23.AfterLoadDFMValues;
    WebLabel6.AfterLoadDFMValues;
    WebLabel7.AfterLoadDFMValues;
    WebComboBox1.AfterLoadDFMValues;
    WebEdit2.AfterLoadDFMValues;
    WebComboBox2.AfterLoadDFMValues;
    WebTrackBar1.AfterLoadDFMValues;
    WebTrackBar2.AfterLoadDFMValues;
  end;
end;

end.
